'use strict';

window.theme = window.theme || {};
window.slate = window.slate || {};

/* ================ SLATE ================ */
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function _createInstance(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function _onSectionLoad(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function _onSectionUnload(evt) {
    this.instances = _.filter(this.instances, function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function _onSelect(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function _onDeselect(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function _onBlockSelect(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function _onBlockDeselect(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function register(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function (index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function wrapTable() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function iframeReset() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function () {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function pageLinkFocus($element) {
    var focusClass = 'js-focus-hidden';

    $element.first().attr('tabIndex', '-1').focus().addClass(focusClass).one('blur', callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function focusHash() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function bindInPageLinks() {
    $('a[href*=#]').on('click', function (evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function trapFocus(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function removeTrapFocus(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = function () {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
}();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    src = src || '';

    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);

    if (match === null) {
      return null;
    } else {
      return match[1];
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
}();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function _getCurrentOptions() {
      var currentOptions = _.map($(this.singleOptionSelector, this.$container), function (element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function _getVariantFromOptions() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function (variant) {
        return selectedValues.every(function (values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function _onSelectChange() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function _updateImages(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function _updatePrice(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function _updateSKU(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function _updateHistoryState(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function _updateMasterSelect(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
}();

/*================ MODULES ================*/
window.Drawers = function () {
  var Drawer = function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('body, html'),
      $page: $('.page-element'),
      $moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);
    this.$open = $(this.config.open);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    this.$open.attr('aria-expanded', 'false');
    this.$open.on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened drawer
    if (this.drawerIsOpen) {
      return;
    }

    this.$open.addClass(this.config.openClass);

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.nodes.$moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Drawer.prototype.close = function () {
    // don't close a closed drawer
    if (!this.drawerIsOpen) {
      return;
    }

    this.$open.removeClass(this.config.openClass);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.nodes.$moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.nodes.$parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function () {
    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function () {
      return false;
    });

    // Clicking out of drawer closes it
    this.nodes.$page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Pressing escape closes drawer
    this.nodes.$parent.on('keyup.drawer', $.proxy(function (evt) {
      if (evt.keyCode === 27) {
        this.close();
      }
    }, this));
  };

  Drawer.prototype.unbindEvents = function () {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
}();

theme.Hero = function () {
  var selectors = {
    hero: '.hero',
    //heroWrapper: '.hero-wrapper',
    heroArrows: '.hero__arrow'
    //heroImage: '.hero__image',
    //heroPause: '.hero__pause'
  };

  function Hero() {
    this.namespace = '.hero';
    this.$hero = $('.hero');
    //this.$hero.on('init' + this.namespace, this._a11y.bind(this));
    this.$hero.on('init' + this.namespace, this._arrowsInit.bind(this));

    this.$hero.slick({
      accessibility: true,
      arrows: false, // this theme has custom arrows
      draggable: false,
      dots: true,
      autoplay: this.$hero.data('autoplay'),
      autoplaySpeed: this.$hero.data('speed')
    });

    /*$(selectors.heroImage).on(
      'click' + this.namespace,
      function() {
        this.$hero.slick('slickNext');
      }.bind(this)
    );*/

    /*$(selectors.heroPause).on(
      'click' + this.namespace,
      function() {
        if ($(selectors.heroPause).hasClass('is-paused')) {
          this._play();
        } else {
          this._pause();
        }
      }.bind(this)
    );*/
  }

  Hero.prototype = _.assignIn({}, Hero.prototype, {
    /*_pause: function() {
      this.$hero.slick('slickPause');
      $(selectors.heroPause).addClass('is-paused');
    },
     _play: function() {
      this.$hero.slick('slickPlay');
      $(selectors.heroPause).removeClass('is-paused');
    },*/

    /*_a11y: function(event, obj) {
      var $list = obj.$list;
       // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');
       // When an element in the slider is focused
      // pause slideshow and set aria-live
      $(selectors.heroWrapper).on(
        'focusin' + this.namespace,
        function(evt) {
          if (!$(selectors.heroWrapper).has(evt.target).length) {
            return;
          }
           $list.attr('aria-live', 'polite');
          this._pause();
        }.bind(this)
      );
       // Resume autoplay
      $(selectors.heroWrapper).on(
        'focusout' + this.namespace,
        function(evt) {
          if (!$(selectors.heroWrapper).has(evt.target).length) {
            return;
          }
           $list.removeAttr('aria-live');
          this._play();
        }.bind(this)
      );
    },*/

    _arrowsInit: function _arrowsInit(event, obj) {
      // Slider is initialized. Setup custom arrows
      var count = obj.slideCount;
      var $slider = obj.$slider;
      var $arrows = $(selectors.heroArrows);

      if ($arrows.length && count > 1) {
        $arrows.on('click' + this.namespace, function (evt) {
          evt.preventDefault();
          if ($(evt.currentTarget).hasClass('hero__arrow--prev')) {
            $slider.slick('slickPrev');
          } else {
            $slider.slick('slickNext');
          }

          //this._scrollTop();
        }.bind(this));
      } else {
        $arrows.remove();
      }
    },

    /*_scrollTop: function() {
      var currentScroll = $(document).scrollTop();
      var heroOffset = this.$hero.offset().top;
       if (currentScroll > heroOffset) {
        $('html')
          .add('body')
          .animate(
            {
              scrollTop: heroOffset
            },
            250
          );
      }
    },*/

    goToSlide: function goToSlide(slideIndex) {
      this.$hero.slick('slickGoTo', slideIndex);
    },

    pause: function pause() {
      this.$hero.slick('slickPause');
    },

    play: function play() {
      this.$hero.slick('slickPlay');
    },

    destroy: function destroy() {
      this.$hero.off(this.namespace);
      //$(selectors.heroImage).off(this.namespace);
      //$(selectors.heroPause).off(this.namespace);
      //$(selectors.heroWrapper).off(this.namespace);
      $(selectors.heroArrows).off(this.namespace);

      this.$hero.slick('unslick');
    }
  });

  return Hero;
}();

window.Modals = function () {
  var Modal = function Modal(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active'
    };

    this.$modal = $('#' + id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $body: $('body')
    };

    this.config = $.extend(defaults, options);

    this.modalIsOpen = false;
    this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
    this.init();
  };

  Modal.prototype.init = function () {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$modal.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Modal.prototype.open = function (evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      return this.close();
    }

    this.$modal.prepareTransition().addClass(this.config.openClass);
    this.nodes.$body.addClass(this.config.openClass);

    this.modalIsOpen = true;

    // Set focus on modal
    slate.a11y.trapFocus({
      $container: this.$modal,
      namespace: 'modal_focus',
      $elementToFocus: this.$focusOnOpen
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Modal.prototype.close = function () {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal.prepareTransition().removeClass(this.config.openClass);
    this.nodes.$body.removeClass(this.config.openClass);

    this.modalIsOpen = false;

    // Remove focus on modal
    slate.a11y.removeTrapFocus({
      $container: this.$modal,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false').focus();
    }

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function () {
    // Pressing escape closes modal
    this.nodes.$body.on('keyup.modal', $.proxy(function (evt) {
      if (evt.keyCode === 27) {
        this.close();
      }
    }, this));
  };

  Modal.prototype.unbindEvents = function () {
    this.nodes.$body.off('.modal');
  };

  return Modal;
}();

window.headerCart = function () {
  var headerCart = function headerCart() {
    this.cache = {
      $classIndicator: 'cart-indicator',
      $cartIconIndicator: $('.cart-indicator__wrap')
    };
  };

  headerCart.prototype.updateIndicator = function (quantity) {
    var link = this.cache.$cartIconIndicator.parent('a');

    // Update cart notification bubble's state
    if (link.length) {
      if (quantity > 0 && !link.hasClass(this.cache.$classIndicator)) {
        link.addClass(this.cache.$classIndicator);
      } else if (quantity == 0 && link.hasClass(this.cache.$classIndicator)) {
        link.removeClass(this.cache.$classIndicator);
      }
    }

    this.cache.$cartIconIndicator.text(quantity > 0 ? quantity : '');
  };

  return headerCart;
}();

window.QtySelector = function () {
  var QtySelector = function QtySelector($el) {
    this.cache = {
      $body: $('body'),
      $subtotal: $('#CartSubtotal'),
      $discountTotal: $('#cartDiscountTotal'),
      $cartTable: $('.cart-table'),
      $cartTemplate: $('#CartProducts')
    };

    this.settings = {
      loadingClass: 'js-qty--is-loading',
      isCartTemplate: this.cache.$body.hasClass('template-cart'),
      // On the cart template, minimum is 0. Elsewhere min is 1
      minQty: this.cache.$body.hasClass('template-cart') ? 0 : 1,
      maxQty: 999
    };

    this.headerCart = new window.headerCart();

    this.$el = $el;
    this.qtyUpdateTimeout;
    this.createInputs();
    this.bindEvents();
  };

  QtySelector.prototype.createInputs = function () {
    var $el = this.$el;

    var data = {
      value: $el.val(),
      key: $el.attr('id'),
      name: $el.attr('name'),
      line: $el.attr('data-line')
    };
    var source = $('#QuantityTemplate').html();
    var template = Handlebars.compile(source);

    this.$wrapper = $(template(data)).insertBefore($el);

    // Remove original number input
    $el.remove();
  };

  QtySelector.prototype.validateAvailability = function (line, quantity) {
    var product = theme.cartObject.items[line - 1]; // 0-based index in API
    var handle = product.handle; // needed for the ajax request
    var id = product.id; // needed to find right variant from ajax results

    var params = {
      type: 'GET',
      url: '/products/' + handle + '.js',
      dataType: 'json',
      success: $.proxy(function (cartProduct) {
        this.validateAvailabilityCallback(line, quantity, id, cartProduct);
      }, this)
    };

    $.ajax(params);
  };

  QtySelector.prototype.validateAvailabilityCallback = function (line, quantity, id, product) {
    var quantityIsAvailable = true;

    // This returns all variants of a product.
    // Loop through them to get our desired one.
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.id === id) {
        break;
      }
    }

    // If the variant tracks inventory and does not sell when sold out
    // we can compare the requested with available quantity
    if (variant.inventory_management !== null && variant.inventory_policy === 'deny') {
      if (variant.inventory_quantity < quantity) {
        // Show notification with error message
        theme.Notify.open('error', theme.strings.noStockAvailable, true);

        // Set quantity to max amount available
        this.$wrapper.find('.js-qty__input').val(variant.inventory_quantity);

        quantityIsAvailable = false;
        this.$wrapper.removeClass(this.settings.loadingClass);
      }
    }

    if (quantityIsAvailable) {
      this.updateItemQuantity(line, quantity);
    }
  };

  QtySelector.prototype.validateQty = function (qty) {
    if (parseFloat(qty) === parseInt(qty, 10) && !isNaN(qty)) {
      qty = qty > this.settings.maxQty ? this.settings.maxQty : qty;
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return parseInt(qty, 10);
  };

  QtySelector.prototype.adjustQty = function (evt) {
    var $el = $(evt.currentTarget);
    var $input = $el.siblings('.js-qty__input');
    var qty = this.validateQty($input.val());
    var line = $input.attr('data-line');

    if ($el.hasClass('js-qty__adjust--minus')) {
      qty -= 1;
      if (qty <= this.settings.minQty) {
        qty = this.settings.minQty;
      }
    } else {
      qty += 1;
      qty = qty > this.settings.maxQty ? this.settings.maxQty : qty;
    }

    if (this.settings.isCartTemplate) {
      $el.parent().addClass(this.settings.loadingClass);
      this.updateCartItemPrice(line, qty);
    } else {
      $input.val(qty);
      $el.trigger('changeQty');
    }
  };

  QtySelector.prototype.bindEvents = function () {
    this.$wrapper.find('.js-qty__adjust').on('click', $.proxy(this.adjustQty, this));

    // Select input text on click
    this.$wrapper.on('click', '.js-qty__input', function () {
      this.setSelectionRange(0, this.value.length);
    });

    // If the quantity changes on the cart template, update the price
    //if (this.settings.isCartTemplate || this.settings.isSideCart) {
    this.$wrapper.on('change', '.js-qty__input', $.proxy(function (evt) {
      var $input = $(evt.currentTarget);
      var qty = this.validateQty($input.val());
      var line = $input.attr('data-line');
      if (this.settings.isCartTemplate) {
        $input.parent().addClass(this.settings.loadingClass);
        this.updateCartItemPrice(line, qty);
      } else {
        $input.val(qty);
        $input.trigger('changeQty');
      }
    }, this));
    //}
  };

  QtySelector.prototype.updateCartItemPrice = function (line, qty) {
    // Update cart after short timeout so user doesn't create simultaneous ajax calls
    clearTimeout(this.qtyUpdateTimeout);
    this.qtyUpdateTimeout = setTimeout($.proxy(function () {
      this.validateAvailability(line, qty);
    }, this), 200);
  };

  QtySelector.prototype.updateItemQuantity = function (line, quantity) {
    var params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      success: $.proxy(function (cart) {
        this.updateCartItemCallback(cart);
      }, this)
    };

    $.ajax(params);
  };

  QtySelector.prototype.updateCartItemCallback = function (cart) {
    // Reload the page to show the empty cart if no items
    if (cart.item_count === 0) {
      location.reload();
      return;
    }

    // Update cart object
    theme.cartObject = cart;

    // Handlebars.js cart layout
    var data = {};
    var items = [];
    var item = {};
    var source = $('#CartProductTemplate').html();
    var template = Handlebars.compile(source);
    var prodImg;
    var count = 0;

    // Add each item to our handlebars.js data
    $.each(cart.items, function (index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add 240x240, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */

      if (cartItem.image === null) {
        prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      } else {
        prodImg = cartItem.image.replace(/(\.[^.]*)$/, '_240x240$1').replace('http:', '');
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function (key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemQty: cartItem.quantity,
        price: theme.Currency.formatMoney(cartItem.price, theme.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: theme.Currency.formatMoney(cartItem.line_price, theme.moneyFormat),
        originalLinePrice: theme.Currency.formatMoney(cartItem.original_line_price, theme.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
      };

      items.push(item);

      count += cartItem.quantity;
    });

    // Gather all cart data and add to DOM
    data = {
      items: items
    };
    this.cache.$cartTemplate.empty().append(template(data));

    // Create new quantity selectors
    this.cache.$cartTable.find('input[type="number"]').each(function (i, el) {
      new QtySelector($(el));
    });

    // Update the cart subtotal
    this.cache.$subtotal.html(theme.Currency.formatMoney(cart.total_price, theme.moneyFormat));
    this.headerCart.updateIndicator(count);

    // Update the cart total discounts
    if (cart.total_discount > 0) {
      this.cache.$discountTotal.html(theme.strings.totalCartDiscount.replace('[savings]', theme.Currency.formatMoney(cart.total_discount, theme.moneyFormat)));
    } else {
      this.cache.$discountTotal.empty();
    }

    // Set focus on cart table
    slate.a11y.pageLinkFocus(this.cache.$cartTable);
  };

  return QtySelector;
}();

window.CartDrawer = function () {
  var CartDrawer = function CartDrawer() {
    this.selectors = {
      cartDrawer: '.drawer-cover',
      ajaxCart: '.cart-drawer',
      itemsHeader: '.cart-drawer__list-header',
      itemList: '[data-cart-item-list]',
      itemId: '[data-cart-item-id]',
      item: '[data-cart-item]',
      itemHref: '[data-cart-item-href]',
      itemImage: '[data-cart-item-image]',
      itemTitle: '[data-cart-item-title]',
      itemQuantity: '[data-cart-item-input-quantity]',
      itemInputQuantity: '[data-cart-item-input-quantity] input',
      itemVariantTitle: '[data-cart-item-variant-title]',
      itemPrice: '[data-cart-item-price]',
      itemOnePrice: '[data-cart-one-item-price]',
      itemOnePriceConteiner: '[data-cart-one-item-price-container]',
      emptyText: '[data-cart-empty-text]',
      cartSubtotal: '[data-cart-subtotal]',
      close: '.cart-drawer__close-button',
      itemDelete: '[data-cart-item-delete]',
      footerCart: '[data-cart-footer]',
      cartMessage: '[data-cart-message]',
      loading: '.cart-drawer__loading'
    };

    this.cache = {
      $cart_drawer: $(this.selectors.cartDrawer),
      $active: 'drawer-cover--open',
      cartError: 'cart-drawer--error',
      cartItemRemove: 'cart-drawer__item--remove',
      cartTemplate: 'cart-drawer__item-template',
      hide: 'cart-drawer__hide',
      scroll: 'scroll-locked'
    };

    this.headerCart = new window.headerCart();

    this.$container = $(this.selectors.ajaxCart).first();

    this.$itemTemplate = $(this.selectors.item, this.$container).first().clone();

    this.bindEvents();
  };

  CartDrawer.prototype._onError = function (error) {
    this.$container.addClass(this.cache.cartError);

    $(this.selectors.item, this.$container).removeClass(this.cache.cartItemRemove);
    $(this.selectors.cartMessage, this.$container).text(theme.strings.cartError);
  };

  CartDrawer.prototype.getCart = function () {
    return $.getJSON('/cart.js');
  };

  CartDrawer.prototype.refresh = function () {
    this.getCart().then(this.update.bind(this)).then(this.bindEvents.bind(this));
  };

  CartDrawer.prototype.deleteRefresh = function (state) {
    var emptyText = $(this.selectors.emptyText),
        footerCart = $(this.selectors.footerCart),
        itemsHeader = $(this.selectors.itemsHeader);
    var count = 0;

    if (emptyText.hasClass(this.cache.hide) && state.items.length == 0) {
      emptyText.removeClass(this.cache.hide);
      footerCart.addClass(this.cache.hide);
      itemsHeader.addClass(this.cache.hide);
    } else if (!emptyText.hasClass(this.cache.hide) && state.items.length > 0) {
      emptyText.addClass(this.cache.hide);
      footerCart.removeClass(this.cache.hide);
      itemsHeader.removeClass(this.cache.hide);
    }

    $(this.selectors.cartSubtotal).html(theme.Currency.formatMoney(state.total_price, theme.moneyFormat));

    //Update Indicator
    $.each(state.items, function (index, cartItem) {
      count += cartItem.quantity;
    });
    this.headerCart.updateIndicator(count);

    return state;
  };

  CartDrawer.prototype.refreshPrice = function (state) {
    var currentItem = state.currentItem;
    var $item;

    if (currentItem) {
      $item = $("[data-item-id='" + currentItem.key + "']");
      this.updatePrice($item, currentItem.original_line_price, currentItem.quantity);
    }

    return state;
  };

  CartDrawer.prototype.updatePrice = function (item, price, quantity) {
    $(this.selectors.itemPrice, item).html(theme.Currency.formatMoney(price, theme.moneyFormat));

    if (quantity == 1) {
      $(this.selectors.itemOnePriceConteiner, item).addClass(this.cache.hide);
    } else {
      $(this.selectors.itemOnePriceConteiner, item).removeClass(this.cache.hide);
    }

    return item;
  };

  CartDrawer.prototype.update = function (state) {
    var $cart = this._createCart(state);

    $(this.cache.$cart_drawer).html($cart[0]);
    this.deleteRefresh(state);
  };

  CartDrawer.prototype._createCart = function (state) {
    var $container = this.$container.clone();

    $container.removeClass(this.cache.cartError);
    $(this.selectors.cartMessage, $container).text('');

    $(this.selectors.itemList, $container).html(this._createItemList(state));

    $(this.selectors.cartSubtotal, $container).html(theme.Currency.formatMoney(state.total_price, theme.moneyFormat));

    return $container;
  };

  CartDrawer.prototype._createItemList = function (state) {
    return $.map(state.items, function (item) {
      var $item = this.$itemTemplate.clone().removeClass(this.cache.cartTemplate);

      $item.attr('data-item-id', item.key);

      $(this.selectors.itemHref, $item).attr('href', item.url);

      $(this.selectors.itemImage, $item).attr('src', item.image ? theme.Images.getSizedImageUrl(item.image, 'medium') : '').toggleClass('hide', typeof item.image !== 'string');

      $(this.selectors.itemTitle, $item).text(item.product_title);

      if (item.variant_title) {
        $(this.selectors.itemVariantTitle, $item).html(item.variant_title.split('/').join('<br />'));
      }

      $(this.selectors.itemInputQuantity, $item).val(item.quantity);

      $(this.selectors.itemOnePrice, $item).html(theme.Currency.formatMoney(item.original_price, theme.moneyFormat));

      $item = this.updatePrice($item, item.original_line_price, item.quantity);

      return $item[0];
    }.bind(this));
  };

  CartDrawer.prototype._promiseChange = function (parameters) {
    var promiseRequest = $.ajax(parameters);

    return promiseRequest
    // Some cart API requests don't return the cart object. If there is no
    // cart object then get one before proceeding.
    .then(function (state) {
      if (typeof state.token === 'undefined') {
        return this.getCart();
      } else {
        return state;
      }
    }.bind(this));
  };

  CartDrawer.prototype.removeItem = function (id) {
    return this._promiseChange({
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        id: id,
        quantity: 0
      }
    });
  };

  CartDrawer.prototype.changeItem = function (id, quantity) {
    var requestSettings = {
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        id: id,
        quantity: parseInt(quantity)
      }
    };

    var currentItem;

    return this._promiseChange(requestSettings).then(function (state) {
      $.each(state.items, function (index, item) {
        if (item.key == id) {
          currentItem = item;
          return false;
        }
      });

      state.currentItem = currentItem;

      return state;
    }.bind(this));
  };

  CartDrawer.prototype._onItemDelete = function (evt) {
    evt.preventDefault();

    var $item = $(evt.target).closest(this.selectors.item);
    var id = $item.data('item-id');

    $(this.selectors.loading).removeClass(this.cache.hide);
    this.removeItem(id).then(this.deleteRefresh.bind(this)).then(function () {
      $item.addClass(this.cache.cartItemRemove);
    }.bind(this)).catch(this._onError.bind(this)).always($.proxy(function (e) {
      $(this.selectors.loading).addClass(this.cache.hide);
    }, this));
  };

  CartDrawer.prototype.onItemQuantityChange = function (evt) {
    var $input = $(evt.target).closest('.js-qty').find('input');
    var id = $input.closest(this.selectors.item).data('item-id');
    var quantity = $input.val();

    // Don't update the cart when a input is empty. Also make sure an input
    // does not remain empty by checking blur event.
    if (quantity === '') return;
    $(this.selectors.loading).removeClass(this.cache.hide);
    this.changeItem(id, quantity).then(this.deleteRefresh.bind(this)).then(this.refreshPrice.bind(this)).catch(this._onError.bind(this)).always($.proxy(function (e) {
      $(this.selectors.loading).addClass(this.cache.hide);
    }, this));
  };

  CartDrawer.prototype.showCart = function () {
    $('html').addClass(this.cache.scroll);
    this.cache.$cart_drawer.addClass(this.cache.$active);
  };

  CartDrawer.prototype.hideCart = function () {
    $('html').removeClass(this.cache.scroll);
    this.cache.$cart_drawer.removeClass(this.cache.$active);
  };

  CartDrawer.prototype.toggleCart = function () {
    if (this.cache.$cart_drawer.hasClass(this.cache.$active)) {
      this.hideCart();
    } else {
      this.showCart();
    }
  };

  CartDrawer.prototype.bindEvents = function () {
    $(this.selectors.close).on('click touch', this.hideCart.bind(this));
    $(this.selectors.itemDelete).on('click', this._onItemDelete.bind(this));

    $(this.cache.$cart_drawer).on('click touch', $.proxy(function (e) {
      if ($(e.target).hasClass(this.cache.$active)) {
        e.stopPropagation();
        e.preventDefault();
        this.hideCart();
      }
    }, this));

    //Item Quantity change Listen
    $(this.selectors.itemInputQuantity).each(function (i, el) {
      new QtySelector($(el));
    });

    $(this.selectors.itemQuantity).on('changeQty', $.debounce(500, this.onItemQuantityChange.bind(this)));
  };

  return CartDrawer;
}();

/*
  Allow product to be added to cart via ajax with
  custom success and error responses.
*/
window.AjaxCart = function () {
  var cart = function cart($form) {
    this.$form = $form;
    this.eventListeners();
  };

  var loading = 'product-form--loading';

  cart.prototype.eventListeners = function () {
    if (this.$form.length) {
      this.$form.on('submit', $.proxy(this.addItemFromForm, this));
    }
  };

  cart.prototype.addItemFromForm = function (evt) {
    evt.preventDefault();

    $(evt.target).addClass(loading);

    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: this.$form.serialize(),
      dataType: 'json',
      success: $.proxy(function (lineItem) {
        if ($('.grouped-products').length) {
          $.when(this.checkGrouped()).done($.proxy(function () {
            setTimeout($.proxy(function () {
              this.success(lineItem);
              $(evt.target).removeClass(loading);
            }, this), 1000);
          }, this));
        } else {
          this.success(lineItem);
          $(evt.target).removeClass(loading);
        }
      }, this),
      error: $.proxy(function (XMLHttpRequest, textStatus) {
        this.error(XMLHttpRequest, textStatus);
        $(evt.target).removeClass(loading);
      }, this)
    };

    $.ajax(params);
  };

  cart.prototype.success = function (item) {
    theme.cartDrawer.refresh();
    theme.cartDrawer.showCart();
  };

  // Error handling reference from Shopify.onError in api.jquery.js
  cart.prototype.error = function (XMLHttpRequest) {
    var data = JSON.parse(XMLHttpRequest.responseText);

    if (data.message) {
      theme.Notify.open('error', data.description, true);
    }
  };

  cart.prototype.checkGrouped = function () {
    var result = [];

    if ($('.grouped-products').length) {
      var groupedProducts = $('.grouped-product-input');

      $.each(groupedProducts, function () {
        var product = $(this).data('product-id');
        var qty = parseInt($(this).val());

        if (qty > 0) {
          var data = 'form_type=product&utf8=%E2%9C%93&quantity=' + qty + '&id=' + product;
          var params = {
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            async: false
          };

          result.push($.ajax(params));
        }
      });
    }

    return result;
  };

  return cart;
}();

window.Notify = function () {
  var notify = function notify() {
    this.cache = {
      $scrollParent: $('html').add('body'),
      $notificationSuccess: $('#NotificationSuccess'),
      $notificationSuccessLink: $('#NotificationSuccess').find('a'),
      $notificationError: $('#NotificationError'),
      $notificationPromo: $('#NotificationPromo'),
      $notificationClose: $('.notification__close'),
      $notificationErrorMessage: $('.notification__message--error')
    };

    this.settings = {
      notifyActiveClass: 'notification--active',
      closeTimer: 5000,
      promoKeyName: 'promo-' + this.cache.$notificationPromo.data('text')
    };

    this.notifyTimer;
    this.$lastFocusedElement = null;

    this.isLocalStorageSupported = isLocalStorageSupported();

    this.cache.$notificationClose.on('click', this.close.bind(this));
    this.showPromo();
  };

  function isLocalStorageSupported() {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    try {
      var storage = window.sessionStorage;
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  notify.prototype.open = function (state, message, autoclose) {
    this.close();

    if (state === 'success') {
      this.cache.$notificationSuccess.attr('aria-hidden', false).addClass(this.settings.notifyActiveClass);

      // Set last focused element to return to once success
      // notification is dismissed (by timeout)
      this.$lastFocusedElement = $(document.activeElement);

      // Set focus on link to cart after transition
      this.cache.$notificationSuccess.one('TransitionEnd webkitTransitionEnd transitionend oTransitionEnd', $.proxy(function () {
        slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink);
      }, this));

      // Fallback for no transitions
      if (this.cache.$scrollParent.hasClass('no-csstransitions')) {
        slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink);
      }
    } else {
      this.cache.$notificationErrorMessage.html(message);
      this.cache.$notificationError.attr('aria-hidden', false).addClass(this.settings.notifyActiveClass);
    }

    // Timeout to close the notification
    if (autoclose) {
      clearTimeout(this.notifyTimer);
      this.notifyTimer = setTimeout(this.close.bind(this), this.settings.closeTimer);
    }
  };

  notify.prototype.close = function (evt) {
    if (evt && $(evt.currentTarget).attr('id') === 'NotificationPromoClose') {
      if (this.isLocalStorageSupported) {
        localStorage.setItem(this.settings.promoKeyName, 'hidden');
      }
    }

    // Return focus to previous element if one is defined
    // and the user has not strayed from the success notification link
    if (this.$lastFocusedElement && this.cache.$notificationSuccessLink.is(':focus')) {
      slate.a11y.pageLinkFocus(this.$lastFocusedElement);
    }

    // Close all notification bars
    this.cache.$notificationSuccess.attr('aria-hidden', true).removeClass(this.settings.notifyActiveClass);
    this.cache.$notificationError.attr('aria-hidden', true).removeClass(this.settings.notifyActiveClass);
    this.cache.$notificationPromo.attr('aria-hidden', true).removeClass(this.settings.notifyActiveClass);

    // Reset last focused element
    this.$lastFocusedElement = null;
  };

  notify.prototype.showPromo = function (SFEevent) {
    // If reloaded in the storefront editor, update selectors/settings
    if (SFEevent) {
      this.initCache();
    }

    if (this.isLocalStorageSupported && localStorage[this.settings.promoKeyName] === 'hidden') {
      return;
    }

    this.cache.$notificationPromo.attr('aria-hidden', false).addClass(this.settings.notifyActiveClass);
  };

  return notify;
}();

theme.Maps = function () {
  var config = {
    zoom: 14,
    styles: [{
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ color: '#cacaca' }, { lightness: 17 }]
    }, {
      featureType: 'landscape',
      elementType: 'geometry',
      stylers: [{ color: '#e1e1e1' }, { lightness: 20 }]
    }, {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [{ color: '#ffffff' }, { lightness: 17 }]
    }, {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#ffffff' }, { lightness: 29 }, { weight: 0.2 }]
    }, {
      featureType: 'road.arterial',
      elementType: 'geometry',
      stylers: [{ color: '#ffffff' }, { lightness: 18 }]
    }, {
      featureType: 'road.local',
      elementType: 'geometry',
      stylers: [{ color: '#ffffff' }, { lightness: 16 }]
    }, {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [{ color: '#e1e1e1' }, { lightness: 21 }]
    }, {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{ color: '#bbbbbb' }, { lightness: 21 }]
    }, {
      elementType: 'labels.text.stroke',
      stylers: [{ visibility: 'on' }, { color: '#ffffff' }, { lightness: 16 }]
    }, {
      elementType: 'labels.text.fill',
      stylers: [{ saturation: 36 }, { color: '#333333' }, { lightness: 40 }]
    }, { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] }, {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{ color: '#f2f2f2' }, { lightness: 19 }]
    }, {
      featureType: 'administrative',
      elementType: 'geometry.fill',
      stylers: [{ color: '#fefefe' }, { lightness: 20 }]
    }, {
      featureType: 'administrative',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#fefefe' }, { lightness: 17 }, { weight: 1.2 }]
    }] // eslint-disable-line key-spacing, comma-spacing
  };
  var apiStatus = null;
  var mapsToLoad = [];

  function Map(container) {
    theme.$currentMapContainer = this.$container = $(container);
    var key = this.$container.data('api-key');

    if (typeof key !== 'string' || key === '') {
      return;
    }

    if (apiStatus === 'loaded') {
      var self = this;

      // Check if the script has previously been loaded with this key
      var $script = $('script[src*="' + key + '&"]');
      if ($script.length === 0) {
        $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key).then(function () {
          apiStatus = 'loaded';
          self.createMap();
        });
      } else {
        this.createMap();
      }
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key).then(function () {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function (index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function (results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function createMap() {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map).then(function (results) {
        var mapOptions = {
          zoom: config.zoom,
          styles: config.styles,
          center: results[0].geometry.location,
          draggable: false,
          clickableIcons: false,
          scrollwheel: false,
          disableDoubleClickZoom: true,
          disableDefaultUI: true
        };

        var map = this.map = new google.maps.Map($map[0], mapOptions);
        var center = this.center = map.getCenter();
        var enablePin = $map.data('enable-pin');

        var markerColor = $map.data('marker-color');

        var markerIcon = {
          path: 'M57.7,0C25.8,0,0,25.8,0,57.7C0,89.5,50,170,57.7,170s57.7-80.5,57.7-112.3C115.3,25.8,89.5,0,57.7,0z M57.7,85 c-14.9,0-27-12.1-27-27c0-14.9,12.1-27,27-27c14.9,0,27,12.1,27,27C84.7,72.9,72.6,85,57.7,85z',
          fillColor: markerColor,
          fillOpacity: 0.9,
          scale: 0.2,
          strokeWeight: 0
        };

        //eslint-disable-next-line no-unused-vars
        var marker = new google.maps.Marker({
          map: map,
          position: center,
          icon: markerIcon,
          visible: enablePin
        });

        google.maps.event.addDomListener(window, 'resize', $.debounce(250, function () {
          google.maps.event.trigger(map, 'resize');
          map.setCenter(center);
        }));
      }.bind(this)).fail(function () {
        var errorMessage;

        switch (status) {
          case 'ZERO_RESULTS':
            errorMessage = theme.strings.addressNoResults;
            break;
          case 'OVER_QUERY_LIMIT':
            errorMessage = theme.strings.addressQueryLimit;
            break;
          default:
            errorMessage = theme.strings.addressError;
            break;
        }

        // Only show error in the theme editor
        if (Shopify.designMode) {
          var $mapContainer = $map.parents('.map-section');

          $mapContainer.addClass('page-width map-section--load-error');
          $mapContainer.find('.map-section__content-wrapper').remove();
          $mapContainer.find('.map-section__wrapper').html('<div class="errors text-center" style="width: 100%;">' + errorMessage + '</div>');
        }
      });
    },

    onUnload: function onUnload() {
      if (typeof window.google !== 'undefined') {
        google.maps.event.clearListeners(this.map, 'resize');
      }
    }
  });

  return Map;
}();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  if (!Shopify.designMode) return;

  theme.$currentMapContainer.addClass('page-width map-section--load-error');
  theme.$currentMapContainer.find('.map-section__content-wrapper').remove();
  theme.$currentMapContainer.find('.map-section__wrapper').html('<div class="errors text-center" style="width: 100%;">' + theme.strings.authError + '</div>');
}

/*theme.stickyHeader = (function() {
  var selectors = {
    searchCartWrapper: '#SiteNavSearchCart',
    stickyNavSearchCart: '#StickyNavSearchCart',
    stickyNavWrapper: '#StickNavWrapper',
    stickyBar: '#StickyBar'
  };

  var config = {
    lastScroll: 0,
    navClass: 'sticky--active',
    openTransitionClass: 'sticky--open',
    closeTransitionClass: 'sticky--close'
  };

  var cache = {};

  function cacheSelectors() {
    cache = {
      $window: $(window),
      $siteNavSearchCart: $(selectors.searchCartWrapper),
      $stickyBar: $(selectors.stickyBar)
    };
  }

  function init() {
    cacheSelectors();
    config.isActive = false;

    // Clone search/cart icons into fixed nav
    if (cache.$siteNavSearchCart.contents().length) {
      cache.$siteNavSearchCart
        .contents()
        .clone()
        .appendTo($(selectors.stickyNavSearchCart));
    }

    cache.$window.on('scroll.stickynav', $.throttle(15, stickyHeaderOnScroll));
  }

  function stickyHeaderOnScroll() {
    var scroll = cache.$window.scrollTop();
    var $el = $(selectors.stickyNavWrapper);
    var threshold = $el.offset().top + $el.height() + 10; // default for scrolling down

    // Check if scrolling up
    if (scroll < config.lastScroll) {
      threshold = $el.offset().top;
    }

    if (scroll > threshold) {
      stickNav();
    } else {
      unstickNav();
    }

    config.lastScroll = scroll;
  }

  function stickNav() {
    if (config.isActive) {
      return;
    }

    config.isActive = true;

    cache.$stickyBar.addClass(config.navClass);

    // Add open transition class after element is set to fixed
    // so CSS animation is applied correctly
    setTimeout(function() {
      cache.$stickyBar.addClass(config.openTransitionClass);
    }, 0);
  }

  function unstickNav() {
    if (!config.isActive) {
      return;
    }

    cache.$stickyBar
      .removeClass(config.openTransitionClass)
      .removeClass(config.navClass);

    config.isActive = false;
  }

  function unload() {
    $(window).off('.stickynav');
  }

  return {
    init: init,
    unload: unload
  };
})();*/

/*theme.headerNav = (function() {
  var selectors = {
    siteNav: '#SiteNav',
    siteNavCompressed: '#SiteNavCompressed',
    siteNavParent: '#SiteNavParent',
    siteNavItem: '.site-nav__item',
    stickyNavWrapper: '#StickNavWrapper',
    stickyNav: '#StickyNav'
  };

  var config = {
    lastScroll: 0,
    isActive: false,
    navClass: 'sticky--active',
    openTransitionClass: 'sticky--open',
    closeTransitionClass: 'sticky--close',
    searchInputClass: 'site-header__search-input',
    searchSubmitClass: 'site-header__search-submit',
    searchInnerActiveClass: 'search-header__search-inner--active'
  };

  function init() {
    sizeNav();
    initHeaderSearch();
    $(window).on('resize.headernav', $.debounce(250, sizeNav));
  }

  function sizeNav() {
    var navWidth = 0;
    var parentWidth = $(selectors.siteNavParent).width();
    var hideClass = 'hide';

    // Set height on nav-bar wrapper so when fixed, doesn't break layout
    $(selectors.stickyNavWrapper).height($(selectors.stickyNav).height());

    // Calculate the width of each nav item
    // after forcing them to be visible for the calculations
    $(selectors.siteNav).removeClass(hideClass);
    $(selectors.siteNavItem).each(function(i, el) {
      navWidth += $(el).width();
    });

    if (navWidth > parentWidth) {
      $(selectors.siteNav).addClass(hideClass);
      $(selectors.siteNavCompressed).removeClass(hideClass);
    } else {
      $(selectors.siteNav).removeClass(hideClass);
      $(selectors.siteNavCompressed).addClass(hideClass);
    }
  }

  function initHeaderSearch() {
    // This function runs after the header search element
    // is duplicated into the sticky nav, meaning there are
    // two search fields to be aware of at this point.
    var $searchForm = $('.site-header__search');

    $searchForm.each(function(i, el) {
      var $form = $(el);
      var $input = $form.find('.' + config.searchInputClass);
      var $submit = $form.find('.' + config.searchSubmitClass);

      $input.add($submit).on('focus blur', function() {
        $form.toggleClass('active-form');
      });

      $submit.on('mousedown', function() {
        if ($form.hasClass('active-form')) {
          $form.submit();
        }
      });
    });
  }

  function unload() {
    $(window).off('.stickynav');
  }

  return {
    init: init,
    unload: unload
  };
})();*/

/*================ TEMPLATES ================*/
theme.customerTemplates = function () {
  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function (evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function (evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    // check if reset password form was successfully submited
    if (!$('.reset-password-success').length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function () {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function () {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function () {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function () {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function init() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
}();

/*================ SECTIONS ================*/
theme.Filters = function () {
  var selectors = {
    filterSelection: '#SortTags',
    sortSelection: '#SortBy'
  };

  function Filters() {
    this.$filterSelect = $(selectors.filterSelection);
    this.$sortSelect = $(selectors.sortSelection);

    this.default = this._getDefaultSortValue();
    this.$sortSelect.val(this.default);

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _getDefaultSortValue: function _getDefaultSortValue() {
      return Shopify.queryParams.sort_by ? Shopify.queryParams.sort_by : this.$sortSelect.data('default-sort');
    },

    _onFilterChange: function _onFilterChange() {
      delete Shopify.queryParams.page;
      if ($.isEmptyObject(Shopify.queryParams)) {
        location.href = this.$filterSelect.val();
      } else {
        location.href = this.$filterSelect.val() + '?' + $.param(Shopify.queryParams);
      }
    },

    _onSortChange: function _onSortChange() {
      Shopify.queryParams.sort_by = this.$sortSelect.val();
      location.search = $.param(Shopify.queryParams);
    },

    onUnload: function onUnload() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
}();

theme.Product = function () {
  var defaults = {
    smallBreakpoint: 750, // copied from variables.scss
    productThumbIndex: 0,
    productThumbMax: 0,
    ajaxCart: false,
    stockSetting: false
  };

  function Product(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');

    this.selectors = {
      originalSelectorId: '#ProductSelect-' + sectionId,
      modal: 'ProductModal',
      productZoomImage: '#ProductZoomImg',
      addToCart: '#AddToCart-' + sectionId,
      productPrice: '#ProductPrice-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      SKU: '.variant-sku',
      productImageContainers: '.product__photo-container-' + sectionId,
      productImageWrappers: '.product__photo-wrapper-' + sectionId,
      productThumbContainers: '.product-single__thumbnail-item-' + sectionId,
      productThumbsWrapper: '.product-single__thumbnails-' + sectionId,
      productThumbs: '.product-single__thumbnail-' + sectionId,
      saleTag: '#ProductSaleTag-' + sectionId,
      productStock: '#ProductStock-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button'
    };

    this.settings = $.extend({}, defaults, {
      sectionId: sectionId,
      ajaxCart: $container.data('ajax'),
      stockSetting: $container.data('stock'),
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.product-' + sectionId
    });

    // Stop parsing if we don't have the product json script tag
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($('#ProductJson-' + sectionId).html());
    this.addVariantInfo();

    this.init();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    init: function init() {
      this._stringOverrides();
      this._initVariants();
      this._productZoomImage();
      this._productThumbSwitch();
      this._productThumbnailSlider();
      this._initQtySelector();

      if (this.settings.ajaxCart) {
        theme.AjaxCart = new window.AjaxCart($('#AddToCartForm-' + this.settings.sectionId));
      }
    },

    _stringOverrides: function _stringOverrides() {
      window.productStrings = window.productStrings || {};
      $.extend(theme.strings, window.productStrings);
    },

    addVariantInfo: function addVariantInfo() {
      if (!this.productSingleObject || !this.settings.stockSetting) {
        return;
      }

      var variantInfo = JSON.parse($('#VariantJson-' + this.settings.sectionId).html());

      for (var i = 0; i < variantInfo.length; i++) {
        $.extend(this.productSingleObject.variants[i], variantInfo[i]);
      }
    },

    _initVariants: function _initVariants() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        product: this.productSingleObject,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId
      };

      // eslint-disable-next-line no-new
      this.variants = new slate.Variants(options);

      this.$container.on('variantChange' + this.settings.namespace, this._updateAddToCartBtn.bind(this));
      this.$container.on('variantPriceChange' + this.settings.namespace, this._updatePrice.bind(this));
      this.$container.on('variantSKUChange' + this.settings.namespace, this._updateSKU.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this._updateImages.bind(this));
    },

    _updateStock: function _updateStock(variant) {
      if (!this.settings.stockSetting) return;

      var $stock = $(this.selectors.productStock);

      // If we don't track variant inventory, hide stock
      if (!variant || !variant.inventory_management) {
        $stock.addClass('hide');
        return;
      }

      if (variant.inventory_quantity < 10 && variant.inventory_quantity > 0) {
        $stock.html(theme.strings.stockAvailable.replace('1', variant.inventory_quantity)).removeClass('hide');
        return;
      }

      if (variant.inventory_quantity <= 0 && variant.incoming) {
        $stock.html(theme.strings.willNotShipUntil.replace('[date]', variant.next_incoming_date)).removeClass('hide');
        return;
      }

      // If there's more than 10 available, hide stock
      $stock.addClass('hide');
    },

    _updateIncomingInfo: function _updateIncomingInfo(variant) {
      if (!this.settings.stockSetting) return;

      var $stock = $(this.selectors.productStock);

      if (variant.incoming) {
        $stock.html(theme.strings.willBeInStockAfter.replace('[date]', variant.next_incoming_date)).removeClass('hide');
        return;
      }

      // If there is no stock incoming, hide stock
      $stock.addClass('hide');
    },

    _updateAddToCartBtn: function _updateAddToCartBtn(evt) {
      var variant = evt.variant;

      var cache = {
        $addToCart: $(this.selectors.addToCart),
        $addToCartText: $(this.selectors.addToCartText)
      };

      if (variant) {
        // Select a valid variant if available
        if (variant.available) {
          // We have a valid product variant, so enable the submit button
          cache.$addToCart.removeClass('btn--sold-out').prop('disabled', false);
          cache.$addToCartText.html(theme.strings.addToCart);
          $(this.selectors.shopifyPaymentButton, this.$container).show();
          // Show how many items are left, if below 10
          this._updateStock(variant);
        } else {
          // Variant is sold out, disable the submit button
          cache.$addToCart.prop('disabled', true).addClass('btn--sold-out');
          cache.$addToCartText.html(theme.strings.soldOut);
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
          // Update when stock will be available
          this._updateIncomingInfo(variant);
        }
      } else {
        cache.$addToCart.prop('disabled', true).removeClass('btn--sold-out');
        cache.$addToCartText.html(theme.strings.unavailable);
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
        // Hide stock display
        this._updateStock();
      }
    },

    _updatePrice: function _updatePrice(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrice).html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));

        // Update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat)).removeClass('hide');
          $(this.selectors.saleTag).removeClass('hide');
        } else {
          $(this.selectors.comparePrice).addClass('hide');
          $(this.selectors.saleTag).addClass('hide');
        }
      } else {
        $(this.selectors.comparePrice).addClass('hide');
      }
    },

    _updateSKU: function _updateSKU(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.SKU).html(variant.sku);
      }
    },

    _updateImages: function _updateImages(evt) {
      var variant = evt.variant;

      if (variant && variant.featured_image) {
        var imageId = variant.featured_image.id;
        this.switchProductImage(imageId);
        this.setActiveThumbnail(imageId);
      }
    },

    switchProductImage: function switchProductImage(imageId) {
      var $imageToShow = $(this.selectors.productImageContainers + "[data-image-id='" + imageId + "']", this.$container);
      var $imagesToHide = $(this.selectors.productImageContainers + ":not([data-image-id='" + imageId + "'])", this.$container);
      $imagesToHide.addClass('hide');
      $imageToShow.removeClass('hide');
    },

    setActiveThumbnail: function setActiveThumbnail(imageId) {
      var $thumbnailToShow = $(this.selectors.productThumbContainers + "[data-image-id='" + imageId + "']", this.$container);
      var $thumbnailsToHide = $(this.selectors.productThumbContainers + ":not([data-image-id='" + imageId + "'])", this.$container);
      $thumbnailsToHide.removeClass('is-active');
      $thumbnailToShow.addClass('is-active');

      var $thumbnails = $(this.selectors.productThumbsWrapper, this.$container);

      // If there is a slick carousel, get the slide index, and position it into view with animation.
      if ($thumbnails.hasClass('slick-initialized')) {
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        var currentActiveSlideIndex = $thumbnails.slick('slickCurrentSlide');
        var newActiveSlideIndex = parseInt($thumbnailToShow.attr('data-slick-index'));
        if (currentActiveSlideIndex !== newActiveSlideIndex) {
          $thumbnails.slick('slickGoTo', newActiveSlideIndex, false);
        }
      }
    },

    _productZoomImage: function _productZoomImage() {
      // The zoom image is only used on the product template, so return early
      // even if a featured product section is present.
      if (!$('.product-single ' + this.selectors.productImageContainers).length) {
        return;
      }

      var self = this;

      $(this.selectors.productImageWrappers).on('click' + this.settings.namespace, function (evt) {
        evt.preventDefault();
        // Empty src before loadig new image to avoid awkward image swap
        $(self.selectors.productZoomImage).attr('src', '').attr('src', $(this).attr('href'));
      });

      this.ProductModal = new window.Modals(this.selectors.modal, 'product-modal');

      // Close modal if clicked, but not if the image is clicked
      this.ProductModal.$modal.on('click' + this.settings.namespace, function (evt) {
        if (evt.target.nodeName !== 'IMG') {
          self.ProductModal.close();
        }
      });
    },

    _productThumbSwitch: function _productThumbSwitch() {
      if (!$(this.selectors.productThumbs).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbs).on('click' + this.settings.namespace, function (evt) {
        evt.preventDefault();
        var imageId = $(this).parent().data('image-id');
        self.setActiveThumbnail(imageId);
        self.switchProductImage(imageId);
      });
    },

    /*
      Thumbnail slider
     */
    _productThumbnailSlider: function _productThumbnailSlider() {
      var $productThumbsWrapper = $(this.selectors.productThumbsWrapper);
      var $productThumbs = $(this.selectors.productThumbs);
      if (!$productThumbs.length) {
        return;
      }

      if ($productThumbs.length > 2) {
        $productThumbsWrapper.on('init' + this.settings.namespace, this._productSwipeInit.bind(this));

        var nextArrow;
        var prevArrow;
        var sliderArrows = window.sliderArrows || false;

        // sliderArrows is an object defined in product.liquid to set custom
        // SVG arrow icons.
        if (sliderArrows) {
          nextArrow = '<button type="button" class="slick-next"><span>' + sliderArrows.right + '</span></button>';
          prevArrow = '<button type="button" class="slick-prev"><span>' + sliderArrows.left + '</span></button>';
        }

        $productThumbsWrapper.slick({
          accessibility: false,
          arrows: true,
          dots: false,
          infinite: false,
          autoplay: false,
          slidesToShow: 5,
          slidesToScroll: 5,
          vertical: false,
          verticalSwiping: false,
          nextArrow: nextArrow,
          prevArrow: prevArrow,
          responsive: [{
            breakpoint: this.settings.smallBreakpoint,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              vertical: false,
              verticalSwiping: false
            }
          }]
        });

        // Show highlighted thumbnail by repositioning slider
        $productThumbsWrapper.slick('slickGoTo', $productThumbsWrapper.find('.is-active').attr('data-slick-index'), true);
      }
    },

    _productSwipeInit: function _productSwipeInit(evt, obj) {
      // Slider is initialized. Setup custom swipe events
      this.settings.productThumbIndex = obj.currentSlide;
      this.settings.productThumbMax = obj.slideCount - 1; // we need the 0-based index

      var self = this;

      $(this.selectors.productImageWrappers).on('swipeleft swiperight', function (event) {
        if (event.type === 'swipeleft') {
          self._goToNextThumbnail();
        }

        if (event.type === 'swiperight') {
          self._goToPrevThumbnail();
        }

        // Trigger click on newly requested thumbnail
        $('.product-single__thumbnail-item[data-slick-index="' + self.settings.productThumbIndex + '"]').find('.product-single__thumbnail').trigger('click');
      });
    },

    _goToNextThumbnail: function _goToNextThumbnail() {
      this.settings.productThumbIndex++;

      if (this.settings.productThumbIndex > this.settings.productThumbMax) {
        this.settings.productThumbIndex = 0;
      }

      $(this.selectors.productThumbsWrapper).slick('slickGoTo', this.settings.productThumbIndex, true);
    },

    _goToPrevThumbnail: function _goToPrevThumbnail() {
      this.settings.productThumbIndex--;

      if (this.settings.productThumbIndex < 0) {
        this.settings.productThumbIndex = this.settings.productThumbMax;
      }

      $(this.selectors.productThumbsWrapper).slick('slickGoTo', this.settings.productThumbIndex, true);
    },

    _initQtySelector: function _initQtySelector() {
      this.$container.find('.product-form__quantity').each(function (i, el) {
        // eslint-disable-next-line no-new
        new QtySelector($(el));
      });
    },

    onUnload: function onUnload() {
      $(this.selectors.productImageWrappers).off(this.settings.namespace);
      $(this.selectors.productThumbs).off(this.settings.namespace);
      $(this.selectors.productThumbs).slick('unslick');
      if (this.ProductModal) {
        this.ProductModal.$modal.off(this.settings.namespace);
      }
    }
  });

  return Product;
}();

theme.Slideshow = function () {
  function Slideshow() {
    this.slideshow = new theme.Hero();
  }

  Slideshow.prototype = _.assignIn({}, Slideshow.prototype, {
    onUnload: function onUnload() {
      this.slideshow.destroy();
    },

    onSelect: function onSelect() {
      this.slideshow.pause();
    },

    onDeselect: function onDeselect() {
      this.slideshow.play();
    },

    onBlockSelect: function onBlockSelect(evt) {
      var $slide = $('.hero__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      this.slideshow.pause();
      this.slideshow.goToSlide(slideIndex);
    },

    onBlockDeselect: function onBlockDeselect() {
      this.slideshow.play();
    }
  });

  return Slideshow;
}();

theme.Cart = function () {
  var selectors = {
    cartNote: '#CartSpecialInstructions',
    cartQtyInput: '.cart__quantity',
    cartNoCookiesClass: 'cart--no-cookies'
  };

  function Cart(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');

    theme.cartObject = JSON.parse($('#CartJson-' + sectionId).html());

    this.init($container);
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    init: function init($container) {
      this._initQtySelector();
      this._initCartNote();

      if (!this._cookiesEnabled()) {
        $container.addClass(selectors.cartNoCookiesClass);
      }
    },

    _initQtySelector: function _initQtySelector() {
      $(selectors.cartQtyInput).each(function (i, el) {
        // eslint-disable-next-line no-new
        new QtySelector($(el));
      });
    },

    _initCartNote: function _initCartNote() {
      if (!$(selectors.cartNote).length) {
        return;
      }

      var $el = $(selectors.cartNote);
      var noteText;
      var params;
      var noteOffset = $el[0].offsetHeight - $el[0].clientHeight;

      // Auto grow the cart note if text fills it up
      $el.on('keyup input', function () {
        $(this).css('height', 'auto').css('height', $el[0].scrollHeight + noteOffset);
      });

      // Save the cart note via ajax. A safeguard in case
      // a user decides to leave the page before clicking 'Update Cart'
      $el.on('change', $.proxy(function () {
        noteText = $el.val();
        params = {
          type: 'POST',
          url: '/cart/update.js',
          data: 'note=' + this._attributeToString(noteText),
          dataType: 'json'
        };
        $.ajax(params);
      }, this));
    },

    _attributeToString: function _attributeToString(attr) {
      if (typeof attr !== 'string') {
        attr = String(attr);
        if (attr === 'undefined') {
          attr = '';
        }
      }
      return $.trim(attr);
    },

    _cookiesEnabled: function _cookiesEnabled() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
}();

theme.Quotes = function () {
  function Quotes(container) {
    this.$container = $(container).on('init', this._a11y.bind(this));

    this.$container.slick({
      accessibility: true,
      arrows: false,
      dots: true,
      draggable: true,
      autoplay: false
    });
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    _a11y: function _a11y(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },

    _goToSlide: function _goToSlide(slideIndex) {
      this.$container.slick('slickGoTo', slideIndex);
    },

    onUnload: function onUnload() {
      delete this.$container;
    },

    onBlockSelect: function onBlockSelect(evt) {
      // Ignore the cloned version
      var $slide = $('.quote__slide-wrapper--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      this._goToSlide(slideIndex);
    }
  });

  return Quotes;
}();

theme.Video = function () {
  var promiseYoutubeAPI;
  var promiseVimeoAPI;

  var youtube = {
    promiseAPI: function promiseAPI() {
      if (!promiseYoutubeAPI) {
        var tag = document.createElement('script');

        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        promiseYoutubeAPI = $.Deferred(function (defer) {
          window.onYouTubeIframeAPIReady = defer.resolve;

          setTimeout(function () {
            defer.reject('Request for YouTube API timed out after 30 seconds.');
          }, 30000);
        });
      }

      return promiseYoutubeAPI;
    },
    promisePlayer: function promisePlayer(id, options) {
      return this.promiseAPI().then(function () {
        return $.Deferred(function (defer) {
          if (typeof window.YT === 'undefined') {
            defer.reject("We're sorry, something went wrong. The YouTube API has not loaded correctly.");
          }

          /* eslint-disable no-undef */
          var player = new YT.Player(id, options); // global YT variable injected by YouTube API

          player.addEventListener('onReady', function () {
            defer.resolve(player);
          });

          setTimeout(function () {
            defer.reject('Request for YouTube player has timed out after 30 seconds.');
          }, 30000);
        });
      });
    }
  };

  var vimeo = {
    promiseAPI: function promiseAPI() {
      if (!promiseVimeoAPI) {
        promiseVimeoAPI = $.Deferred(function (defer) {
          var tag = document.createElement('script');
          tag.src = 'https://player.vimeo.com/api/player.js';
          tag.onload = tag.onreadystatechange = function () {
            if (!this.readyState || this.readyState === 'complete') {
              defer.resolve();
            }
          };

          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          setTimeout(function () {
            defer.reject('Request for Vimeo API timed out after 30 seconds.');
          }, 30000);
        });
      }

      return promiseVimeoAPI;
    },

    promisePlayer: function promisePlayer(id, options) {
      return this.promiseAPI().then(function () {
        return $.Deferred(function (defer) {
          if (typeof window.Vimeo === 'undefined') {
            defer.reject("We're sorry, something went wrong. The Vimeo API has not loaded correctly.");
          }

          var player = new window.Vimeo.Player(id, options);

          setTimeout(function () {
            defer.reject('Request for Vimeo player has timed out after 30 seconds.');
          }, 30000);

          player.ready().then(function () {
            defer.resolve(player);
          });
        });
      });
    }
  };

  var selectors = {
    loadPlayerButton: '.video-section__load-player-button',
    closePlayerButton: '.video-section__player-close',
    playerContainer: '.video-section__player',
    cover: '.video-section__cover',
    errorMessage: '.video-section__error',
    bodyOverlay: '.video-section__body-overlay',
    body: 'body'
  };
  var classes = {
    playerLoading: 'video-section--loading',
    playerLoaded: 'video-section--loaded',
    playerError: 'video-section--error',
    videoPlaying: 'video-playing'
  };

  function Video(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');
    this.namespace = '.' + sectionId;
    this.onLoad();
  }

  Video.prototype = _.assignIn({}, Video.prototype, {
    onLoad: function onLoad() {
      this.$container.on('click', selectors.loadPlayerButton, this._loadPlayer.bind(this)).on('click', selectors.closePlayerButton, this._closePlayer.bind(this)).on('click', selectors.bodyOverlay, this._closePlayer.bind(this));
    },

    _loadPlayer: function _loadPlayer() {
      var $container = this.$container;
      var $playerContainer = $(selectors.playerContainer, $container);
      var playerType = this.$container.attr('data-video-type');

      var promiseVideoPlayer;

      if (playerType === 'youtube') {
        promiseVideoPlayer = this._loadYoutubePlayer($playerContainer[0]);
      } else if (playerType === 'vimeo') {
        promiseVideoPlayer = this._loadVimeoPlayer($playerContainer[0]);
      }

      return promiseVideoPlayer.then(this._onPlayerLoadReady.bind(this)).fail(this._onPlayerLoadError.bind(this));
    },

    _loadYoutubePlayer: function _loadYoutubePlayer(container) {
      return youtube.promisePlayer(container, {
        videoId: this.$container.attr('data-video-id'),
        ratio: 16 / 9,
        playerVars: {
          modestbranding: 1,
          autoplay: 1,
          showinfo: 0,
          rel: 0
        }
      }).then(function (player) {
        this.player = player;
      }.bind(this));
    },

    _loadVimeoPlayer: function _loadVimeoPlayer(container) {
      return vimeo.promisePlayer(container, {
        id: this.$container.attr('data-video-id')
      }).then(function (player) {
        this.player = player;
        this.player.play();
      }.bind(this));
    },

    _onPlayerLoadReady: function _onPlayerLoadReady() {
      $(selectors.closePlayerButton, this.$container).show().focus();
      $(selectors.cover, this.$container).addClass(classes.playerLoaded);
      this.$container.addClass(classes.playerLoaded);

      this._setScrollPositionValues();

      $(selectors.body).addClass(classes.videoPlaying);

      $(document).on('keyup' + this.namespace, this._closeOnEscape.bind(this));
      $(window).on('resize' + this.namespace, this._setScrollPositionValues.bind(this));
      slate.a11y.trapFocus({
        $container: this.$container,
        namespace: this.namespace
      });
    },

    _onPlayerLoadError: function _onPlayerLoadError(err) {
      this.$container.addClass(classes.playerError);
      $(selectors.errorMessage, this.$container).text(err);
    },

    _closeOnEscape: function _closeOnEscape(evt) {
      if (evt.keyCode !== 27) {
        return;
      }

      this._closePlayer();
      $(selectors.loadPlayerButton, this.$container).focus();
    },

    _onScroll: function _onScroll() {
      var scrollTop = $(window).scrollTop();

      if (scrollTop > this.videoTop + 0.25 * this.videoHeight || scrollTop + this.windowHeight < this.videoBottom - 0.25 * this.videoHeight) {
        // Debounce DOM edits to the next frame with requestAnimationFrame
        requestAnimationFrame(this._closePlayer.bind(this));
      }
    },

    _setScrollPositionValues: function _setScrollPositionValues() {
      this.videoHeight = this.$container.outerHeight(true);
      this.videoTop = this.$container.offset().top;
      this.videoBottom = this.videoTop + this.videoHeight;
      this.windowHeight = $(window).innerHeight();
    },

    _closePlayer: function _closePlayer() {
      $(selectors.body).removeClass(classes.videoPlaying);
      $(selectors.cover, this.$container).removeClass(classes.playerLoaded);
      this.$container.removeClass(classes.playerLoaded);
      $(selectors.closePlayerButton, this.$container).hide();

      slate.a11y.removeTrapFocus({
        $container: this.$container,
        namespace: this.namespace
      });

      if (typeof this.player.destroy === 'function') {
        this.player.destroy();
      } else if (typeof this.player.unload === 'function') {
        this.player.unload();
      }

      $(document).off(this.namespace);
      $(window).off(this.namespace);
    }
  });

  return Video;
}();

theme.CollectionsList = function () {
  function CollectionsList(container) {
    var $container = this.$container = $(container);
    var stretchImage = $container.is('[data-stretch-image]');

    // Early return if 'secondary image layout' is enabled
    if (stretchImage) return;

    var namespace = this.namespace = '.' + $container.attr('data-section-id');
    var self = this;

    self._collectionListFix();
    $(window).on('resize' + namespace, $.debounce(250, function () {
      self._collectionListFix();
    }));
  }

  CollectionsList.prototype = _.assignIn({}, CollectionsList.prototype, {
    onUnload: function onUnload() {
      $(window).off(this.namespace);
    },

    _collectionListFix: function _collectionListFix() {
      var numberRows = this.$container.find('.grid').data('number-rows');
      var $featureCards = this.$container.find('.featured-card');

      // We can exit if 'Use secondary image layout' is enabled
      if ($featureCards.is('[data-stretch-image]')) return;

      // Go through each of the rows
      for (var i = 0; i < numberRows; i++) {
        var maxWrapperHeight = 0;
        var maxHeaderHeight = 0;
        var $currentRow = $featureCards.filter("[data-row-number='" + (i + 1) + "']");
        var $cardHeaders = $currentRow.find('.featured-card__header');

        // Find the max heights for each row
        $currentRow.each(function () {
          var $cardTitle = $(this).find('.featured-card__title');
          var $cardAction = $(this).find('.featured-card__action');
          var $cardImageWrapper = $(this).find('.featured-card__image-wrapper');
          var headerHeight = $cardTitle.outerHeight() + $cardAction.outerHeight() + 65;
          var wrapperHeight = $cardImageWrapper.outerHeight();
          if (headerHeight > maxHeaderHeight) {
            maxHeaderHeight = headerHeight;
          }
          if (wrapperHeight > maxWrapperHeight) {
            maxWrapperHeight = wrapperHeight;
          }
        });

        // Set the heights of the headers and cards for this row with padding
        $cardHeaders.outerHeight(maxHeaderHeight);
        $currentRow.height(maxWrapperHeight + maxHeaderHeight + 40);
      }
    }
  });

  return CollectionsList;
}();

theme.init = function () {
  theme.Notify = new window.Notify();
  theme.cartDrawer = new window.CartDrawer();

  theme.customerTemplates.init();
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function (evt) {
    evt.preventDefault();
  });

  // Sections
  var sections = new theme.Sections();
  sections.register('product', theme.Product);
  sections.register('featured-product', theme.Product);
  sections.register('collection-filters', theme.Filters);
  sections.register('map', theme.Maps);
  sections.register('slideshow', theme.Slideshow);
  sections.register('cart', theme.Cart);
  sections.register('quotes', theme.Quotes);
  sections.register('video', theme.Video);
  sections.register('collections-list', theme.CollectionsList);

  //CartDrawer init
  $('.cart-toggle').on('click', function (e) {
    if ($(e.target).closest(".template-cart").length == 0) {
      e.stopPropagation();
      e.preventDefault();
      theme.cartDrawer.toggleCart();
    }
  });

  // Standalone modules
  $(window).on('load', theme.articleImages);
  theme.passwordModalInit();
};

theme.articleImages = function () {
  var $indentedRteImages = $('.rte--indented-images');
  if (!$indentedRteImages.length) {
    return;
  }

  $indentedRteImages.find('img').each(function (i, el) {
    var $el = $(el);
    var attr = $el.attr('style');

    // Check if undefined or float: none
    if (!attr || attr === 'float: none;') {
      // Add class to parent paragraph tag if image is wider than container
      if ($el.width() >= $indentedRteImages.width()) {
        $el.parent('p').addClass('rte__image-indent');
      }
    }
  });
};

theme.passwordModalInit = function () {
  var $loginModal = $('#LoginModal');
  if (!$loginModal.length) {
    return;
  }

  // Initialize modal
  theme.PasswordModal = new window.Modals('LoginModal', 'login-modal', {
    focusOnOpen: '#Password'
  });

  // Open modal if errors exist
  if ($loginModal.find('.errors').length) {
    theme.PasswordModal.open();
  }
};

$(theme.init);
'use strict';

document.addEventListener("DOMContentLoaded", DOMReady);

function DOMReady() {
    fixTableContent();
}

function fixImgArticleAlign() {
    var article = document.getElementById('shopify-section-article-content');
    var imgs = article.getElementsByTagName('img');
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = imgs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            var this_p = item.closest('p');
            if (this_p) {
                this_p.classList.add('no-padding');
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

function fixTableContent() {
    var article = document.getElementById('shopify-section-article-content');

    if (article) {
        var tables = article.getElementsByTagName('table');
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = tables[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var table = _step2.value;

                if (table) {
                    table.parentElement.classList.add('table-parent');
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    }
}
"use strict";

document.addEventListener("DOMContentLoaded", DOMReady);

function DOMReady() {
	if (!window.ActiveXObject && "ActiveXObject" in window) {
		document.body.classList.add('ie11');
	}
}
'use strict';

function doOnFormElementFocused(elm) {
    elm.removeClass('field-bg-transparent');
}

function doOnFormElementBlured(elm) {
    if (!elm.val()) {
        elm.addClass('field-bg-transparent');
    }
}

function initFormPlaceholders(formElm) {
    var formControls = formElm.find('input[type="text"], input[type="email"], input[type="tel"], input[type="password"], textarea');
    formControls.each(function () {
        if (!$(this).val()) {
            $(this).addClass('field-bg-transparent');
        }
        formElm.find('label').css('display', 'block');
        $(this).bind('focus', function () {
            doOnFormElementFocused($(this));
        });
        $(this).bind('blur', function () {
            doOnFormElementBlured($(this));
        });
    });
}

function setNiceSelectRequiredLabel(formElm) {
    var select = formElm.find('select');
    select.each(function () {
        if ($(this).is(':required')) {
            var firstOption = $(this).parent().find('.nice-select').find('.option').eq(0);
            firstOption.addClass('disabled');
            firstOption.html(firstOption.text() + '&nbsp;<span class="required-label">*</span>');
            if (firstOption.hasClass('selected')) {
                firstOption.parent().parent().find('.current').html(firstOption.html());
            }
        }
    });
}

function setNiceSelectOptionListMaxHeight() {
    $('.nice-select').find('.list').css('max-height', Math.min(300, $(window).height() - 58));
}

function setNiceSelectPlaceholderTxt(elm) {
    var placeholderTxt = elm.parent().find('label').html();
    elm.parent().find('.nice-select').find('.option').eq(0).html(placeholderTxt);
    elm.parent().find('.nice-select').find('.current').html(placeholderTxt);
}

function bindNiceSelectOnFocus(elmList) {
    elmList.each(function () {
        $(this).bind('focus', function () {
            $(this).blur();
            $(this).parent().find('.nice-select').focus();
        });
    });
}

function setNiceSelectTabindex(elmList) {
    elmList.attr('tabindex', '-1');
}

function initNiceSelect(formElm, fnExt) {
    var elmList = formElm.find('select');
    elmList.niceSelect();
    setNiceSelectRequiredLabel(formElm);
    setNiceSelectOptionListMaxHeight();
    bindNiceSelectOnFocus(elmList);
    setNiceSelectTabindex(elmList);
    $(window).resize(function () {
        setNiceSelectOptionListMaxHeight();
    });
    if ($.isFunction(fnExt)) {
        fnExt();
    }
}
'use strict';

(function ($) {
  $(document).ready(function() {
      var CODE = "US";

    var countryCode = getCookie('country_code'),
        geoIp = theme.geoIp;

    function handleResponse(response) {
        var locationCountryCode = response.country_code2;
        locationCountryCode = typeof locationCountryCode !== 'undefined' ? locationCountryCode : CODE;
        setCookie('country_code', locationCountryCode, 0, 1);
        prepareContent(locationCountryCode);
    }

    function prepareContent(location) {
      if (location != 'US') {
        var locale =  getQueryVariable('locale');
        if (locale !== false && locale.toLowerCase() == 'en-us') location = 'US';
      }
      console.log(location);
        if (location != 'US') {
            checkRedirect('US');
            $('.US').remove();
            $('.INTL').show();
        } else {
            checkRedirect('INTL');
              $('.INTL').remove();
              $('.US').show();
        }
    }

    if (geoIp === true) {
        prepareContent(CODE);
    } else if (typeof countryCode !== 'undefined' && countryCode !== '') {
        prepareContent(countryCode);
    } else {
        getGeolocation(handleResponse.bind(this), "777608e6815044638f77282af81528db");
    }

    function checkRedirect(className) {
        var element = $('.redirect-check');
        if (element.length) {
            var url = element.data('url');
            url = typeof url == "undefined" || url == '' ? '/' : url;

            if (element.hasClass(className)) {
                window.location.href = url;
            }
        }
    }
    
    function getQueryVariable(variable)
    {
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return pair[1];}
       }
       return(false);
    }
  })

})(jQuery);
'use strict';

(function ($) {
  var active = 'active',
      submenuActive = 'sub-active',
      torMenuAim = '.tor-aim-menu';

  $('document').ready(function () {
    var mainNave = $('.nav-main'),
        mainNavList = $('.nav-main__list'),
        mainNavListItem = $('.nav-main__list-item'),
        submenuListItem = $('.nav-main__submenu:not(' + torMenuAim + ') .nav-main__submenu-item'),
        imgs = mainNave[0].getElementsByClassName('nav-collection__image');

    function addEventListener() {
      mainNavListItem.on({
        mouseenter: function mouseenter() {
          if (!$(this).hasClass(active)) {
            $(this).addClass(active);
          }
        },
        mouseleave: function mouseleave() {
          if (!!$(this).hasClass(active)) {
            $(this).removeClass(active);
          }

          //Remove all Submenu active items
          $(this).find('.' + submenuActive).each(function (index, item) {
            $(item).removeClass(submenuActive);
          });
        }
      });

      submenuListItem.on({
        mouseenter: function mouseenter() {
          if (!$(this).hasClass(submenuActive)) {
            $(this).addClass(submenuActive);
          }
        },
        mouseleave: function mouseleave() {
          if (!!$(this).hasClass(submenuActive)) {
            $(this).removeClass(submenuActive);
          }
        }
      });
    }

    function activateSubmenu(row) {
      var elem = $(row);
      loadImages(elem);
      elem.addClass(submenuActive);
      //proportionalResizeImgs();
      setSubmenuHeight();
    }

    function deactivateSubmenu(row) {
      $(row).removeClass(submenuActive);
    }

    function aimMenuActivate() {
      var $menu = $(torMenuAim);

      if ($menu.length) {
        $menu.menuAim({
          activate: activateSubmenu,
          deactivate: deactivateSubmenu,
          exitMenu: function exitMenu() {
            return true;
          }
        });
      }
    }

    function setSubmenuHeight() {
      mainNavListItem.each(function (index, item) {
        var element = $(item),
            subMenu = element.find('.nav-main__submenu'),
            subMenuSecond = element.find('.nav-main__submenu-second'),
            subMenuHeight = 0,
            flag = false;

        if (subMenuSecond.length > 0) {
          subMenu.show();
          subMenuHeight = 0;

          subMenuSecond.each(function (key, subItem) {
            var subItemElement = $(subItem),
                contentHeight = 0;

            var subItemElementStyleInit = subItemElement.attr('style');

            subItemElement.show();

            contentHeight = subItemElement.find('.nav-collection').eq(0).outerHeight(true);

            //subItemElement.removeAttr('style');
            subItemElement.attr('style', subItemElementStyleInit);
            contentHeight = contentHeight + parseInt(subItemElement.css('padding-top'));

            if (contentHeight >= subMenuHeight) {
              subMenuHeight = contentHeight;
              flag = true;
            }
          });
          subMenu.removeAttr('style');

          //if(flag) {
          subMenu.css('min-height', subMenuHeight + 20);
          //}
        }
      });
    }

    function initNav() {
      addEventListener();
      aimMenuActivate();
      doResizeNavMainSubmenuSecond();
      setSubmenuHeight();

      // For IE, Edge
      bindResizeNavMainSubmenuSecond();
    }

    function setWidthNavMainSubmenuSecond(navMainSubmenuSecond) {
      var parentElm = navMainSubmenuSecond.parent().parent().parent().parent();
      var itemWidth = $(window).width() - (parentElm.offset().left + parentElm.outerWidth());
      navMainSubmenuSecond.width(itemWidth);
    }

    function bindResizeNavMainSubmenuSecond() {
      $(window).resize(function () {
        doResizeNavMainSubmenuSecond();
        setSubmenuHeight();
      });
    }

    function doResizeNavMainSubmenuSecond() {
      var navMainSubmenuSecondList = $('.tor-header__manu').find('.nav-main__submenu-second');
      navMainSubmenuSecondList.each(function () {
        setWidthNavMainSubmenuSecond($(this));
      });
    }

    function loadImages(elem) {
      elem.find('.nav-collection__image').each(function (key, item) {
        var link = $(item),
            src = link.data('img');

        if (!link.find('img').length && src !== '') {
          link.append('<img src="' + src + '">');
        }
      });
    }

    function proportionalResizeImgs() {
      for (var i = 0; i < imgs.length; i++) {
        var w = imgs[i].offsetWidth;
        imgs[i].style.height = w + 'px';
      }
    }

    if (mainNave.length) {
      initNav();
    }
  });
})(jQuery);
'use strict';

function bindHamburgerOnClick() {
    $('.hamburger').on('click', function () {
        toggleHamburgerIco();
        toggleMenuMobile();
    });
}

function toggleHamburgerIco() {
    $('.hamburger-icon').toggleClass('open');
}

function toggleMenuMobile() {
    var body = $('body');
    body.toggleClass('nav-open');
    if (!body.hasClass('nav-open')) {
        resetMenuMobile();
        resetMenuMobileLinkParent();
        resetMenuMobileLinkBack();
    }
    $('.tor-header__menu-mobile').toggleClass('open');
}

function menuMobileInit() {
    bindHamburgerOnClick();
    bindMenuMobileItemLvl1OnClick();
    bindMenuMobileItemLvl2OnClick();
    bindMenuMobileItemLvl3OnClick();
    setMenuMobileLinkSimpleClass();

    setMenuMobileLinkParentDefaultData();
    setMenuMobileLinkParentDefault();

    setMenuMobileLinkBackDefaultData();
    setMenuMobileLinkBackDefault();

    bindMenuMobileOnWindowResize();
}

function getMenuMobileLinkBackElm() {
    return $('#menuMobileLinkBack');
}

function setMenuMobileLinkBackDefaultData() {
    var menuMobileLinkBack = getMenuMobileLinkBackElm();
    menuMobileLinkBack.data('defaultLabel', '');
    menuMobileLinkBack.data('defaultHref', 'javascript: void(0)');
    menuMobileLinkBack.data('defaultClass', 'back-link-disabled');
}

function setMenuMobileLinkBackDefault() {
    var menuMobileLinkBack = getMenuMobileLinkBackElm();
    menuMobileLinkBack.html(menuMobileLinkBack.data('defaultLabel'));
    menuMobileLinkBack.attr('href', menuMobileLinkBack.data('defaultHref'));
    menuMobileLinkBack.addClass(menuMobileLinkBack.data('defaultClass'));
}

function resetMenuMobileLinkBack() {
    setMenuMobileLinkBackDefault();
}

function setMenuMobileLinkParentDefaultData() {
    var menuMobileLinkParent = getMenuMobileLinkParentElm();
    menuMobileLinkParent.data('defaultLabel', '&nbsp;');
    menuMobileLinkParent.data('defaultHref', 'javascript: void(0)');
    menuMobileLinkParent.data('defaultClass', 'parent-link-disabled');
}

function getMenuMobileLinkParentElm() {
    return $('#menuMobileLinkParent');
}

function setMenuMobileLinkParentDefault() {
    var menuMobileLinkParent = getMenuMobileLinkParentElm();
    menuMobileLinkParent.html(menuMobileLinkParent.data('defaultLabel'));
    menuMobileLinkParent.attr('href', menuMobileLinkParent.data('defaultHref'));
    menuMobileLinkParent.addClass(menuMobileLinkParent.data('defaultClass'));
}

function resetMenuMobileLinkParentClass() {
    var menuMobileLinkParent = getMenuMobileLinkParentElm();
    menuMobileLinkParent.removeClass('parent-link-disabled');
    menuMobileLinkParent.removeClass('parent-link-active');
}

function resetMenuMobileLinkParent() {
    resetMenuMobileLinkParentClass();
    setMenuMobileLinkParentDefault();
}

function setMenuMobileLinkParentClass(elm) {
    resetMenuMobileLinkParentClass();
    var cssClass = getMenuMobileLinkParentCurrentClass(elm);
    var menuMobileLinkParent = getMenuMobileLinkParentElm();
    menuMobileLinkParent.addClass(cssClass);
}

function getMenuMobileLinkParentCurrentClass(elm) {
    var cssClass = elm.attr('href') ? 'parent-link-active' : 'parent-link-disabled';
    return cssClass;
}

function setMenuMobileLinkBackLvl1() {
    var menuMobileLinkBack = getMenuMobileLinkBackElm();
    var label = "Main Menu";
    menuMobileLinkBack.text(label);
    menuMobileLinkBack.removeClass('back-link-disabled');
    menuMobileLinkBack.off('click');
    menuMobileLinkBack.on('click', function () {
        $(this).parent().removeClass('open');
        $('.nav-mobile__list-item.open').removeClass('open');
        $('.nav-mobile__list').removeClass('open-lvl-2');
        setMenuMobileLinkBackDefault();
        restoreMenuMobileLinkParentLvl0();
        $(this).off('click');
    });
}

function restoreMenuMobileLinkParentLvl0() {
    resetMenuMobileLinkParent();
    var menuMobileLinkParent = getMenuMobileLinkParentElm();
    menuMobileLinkParent.data('currentLvl', '1');
}

function bindMenuMobileItemLvl1OnClick() {
    $('.nav-mobile__list-link').on('click', function (e) {
        if ($(this).next('.nav-mobile__submenu-wrap').length) {
            var t = $(this);
            preventEventDefault(e);
            $(this).parent().addClass('open');
            $(this).parent().parent().addClass('open-lvl-2');

            setMenuMobileLinkParentLvl1(t);
            setMenuMobileLinkBackLvl1();
        }
    });
}

function setMenuMobileLinkParentLvl1(elm) {
    var menuMobileLinkParent = getMenuMobileLinkParentElm();
    menuMobileLinkParent.data('lvl1Label', menuMobileLinkParent.data('defaultLabel'));
    menuMobileLinkParent.data('lvl1Href', menuMobileLinkParent.data('defaultHref'));

    menuMobileLinkParent.data('lvl2Label', elm.text());
    menuMobileLinkParent.data('lvl2Href', elm.attr('href') ? elm.attr('href') : 'javascript: void(0)');
    menuMobileLinkParent.data('lvl2Class', getMenuMobileLinkParentCurrentClass(elm));

    menuMobileLinkParent.data('currentLvl', '2');

    menuMobileLinkParent.html(menuMobileLinkParent.data('lvl2Label'));
    menuMobileLinkParent.attr('href', menuMobileLinkParent.data('lvl2Href'));
    setMenuMobileLinkParentClass(elm);
}

function setMenuMobileLinkBackLvl2(elm) {
    var menuMobileLinkBack = getMenuMobileLinkBackElm();
    var label = elm.parent().parent().parent().parent().find('.nav-mobile__list-link').text();
    menuMobileLinkBack.text(label);
    menuMobileLinkBack.removeClass('back-link-disabled');
    menuMobileLinkBack.off('click');
    menuMobileLinkBack.on('click', function () {
        elm.parent().removeClass('open');
        elm.next('.nav-mobile__submenu-second').find('.open').removeClass('open');
        elm.next('.nav-mobile__submenu-second').find('.nav-collection__list').css('display', 'none');
        $('.nav-mobile__list').removeClass('open-lvl-3');
        $('.nav-mobile__submenu-item.open').removeClass('open');

        setMenuMobileLinkBackLvl1();
        restoreMenuMobileLinkParentLvl1();
    });
}

function restoreMenuMobileLinkParentLvl1() {
    var menuMobileLinkParent = getMenuMobileLinkParentElm();
    menuMobileLinkParent.html(menuMobileLinkParent.data('lvl2Label'));
    menuMobileLinkParent.attr('href', menuMobileLinkParent.data('lvl2Href'));
    resetMenuMobileLinkParentClass();
    menuMobileLinkParent.addClass(menuMobileLinkParent.data('lvl2Class'));
    menuMobileLinkParent.data('currentLvl', '2');
}

function bindMenuMobileItemLvl2OnClick() {
    $('.nav-mobile__submenu-item a').on('click', function (e) {
        if ($(this).next('.nav-mobile__submenu-second').length) {
            preventEventDefault(e);
            $(this).parent().addClass('open');
            $('.open-lvl-2').addClass('open-lvl-3');

            var t = $(this);
            setMenuMobileLinkParentLvl2(t);
            setMenuMobileLinkBackLvl2(t);
        }
    });
}

function setMenuMobileLinkParentLvl2(elm) {
    var menuMobileLinkParent = getMenuMobileLinkParentElm();
    menuMobileLinkParent.data('lvl3Label', elm.text());
    menuMobileLinkParent.data('lvl3Href', elm.attr('href') ? elm.attr('href') : 'javascript: void(0)');
    menuMobileLinkParent.data('lvl3Class', getMenuMobileLinkParentCurrentClass(elm));

    menuMobileLinkParent.data('currentLvl', '3');

    menuMobileLinkParent.html(menuMobileLinkParent.data('lvl3Label'));
    menuMobileLinkParent.attr('href', menuMobileLinkParent.data('lvl3Href'));
    setMenuMobileLinkParentClass(elm);
}

function bindMenuMobileItemLvl3OnClick() {
    $('.tor-header__menu-mobile-wrap').find('.nav-collection__title').on('click', function (e) {
        if ($(this).next('.nav-collection__list').length) {
            preventEventDefault(e);
            $(this).parent().parent().toggleClass('open');

            var prevAllOpen = $(this).parent().parent().prevAll('.nav-collection__item.open');
            var nextAllOpen = $(this).parent().parent().nextAll('.nav-collection__item.open');
            prevAllOpen.find('.nav-collection__title').toggleClass('open');
            prevAllOpen.find('.nav-collection__list').slideToggle();
            prevAllOpen.removeClass('open');
            nextAllOpen.find('.nav-collection__title').toggleClass('open');
            nextAllOpen.find('.nav-collection__list').slideToggle();
            nextAllOpen.removeClass('open');

            $(this).next('.nav-collection__list').slideToggle();

            $(this).toggleClass('open');
            if ($(this).hasClass('open')) {
                setMenuMobileLinkParentLvl3($(this));

                $('.open-lvl-3').addClass('open-lvl-4');
            } else {
                restoreMenuMobileLinkParentLvl2();
                $('.open-lvl-3').removeClass('open-lvl-4');
            }
        }
    });
}

function restoreMenuMobileLinkParentLvl2() {
    var menuMobileLinkParent = getMenuMobileLinkParentElm();
    menuMobileLinkParent.html(menuMobileLinkParent.data('lvl3Label'));
    menuMobileLinkParent.attr('href', menuMobileLinkParent.data('lvl3Href'));
    resetMenuMobileLinkParentClass();
    menuMobileLinkParent.addClass(menuMobileLinkParent.data('lvl3Class'));
    menuMobileLinkParent.data('currentLvl', '3');
}

function setMenuMobileLinkParentLvl3(elm) {
    var menuMobileLinkParent = getMenuMobileLinkParentElm();
    menuMobileLinkParent.data('lvl4Label', elm.text());
    menuMobileLinkParent.data('lvl4Href', elm.attr('href') ? elm.attr('href') : 'javascript: void(0)');
    menuMobileLinkParent.data('lvl4Class', getMenuMobileLinkParentCurrentClass(elm));

    menuMobileLinkParent.data('currentLvl', '4');

    menuMobileLinkParent.html(menuMobileLinkParent.data('lvl4Label'));
    menuMobileLinkParent.attr('href', menuMobileLinkParent.data('lvl4Href'));
    setMenuMobileLinkParentClass(elm);
}

function resetMenuMobile() {
    $('body').removeClass('nav-open');
    $('.nav-mobile__list').removeClass('open-lvl-2').removeClass('open-lvl-3').removeClass('open-lvl-4');
    $('.tor-header__menu-mobile-wrap').find('.nav-collection__list').css('display', 'none');
    $('.tor-header__menu-mobile').find('.open').removeClass('open');
}

function setMenuMobileLinkSimpleClass() {
    var linksLvl2 = $('.nav-mobile__submenu-item > a');
    if (linksLvl2.length) {
        linksLvl2.each(function () {
            if (!$(this).next('.nav-mobile__submenu-second').length) {
                $(this).addClass('link-simple');
            }
        });
    }

    var linksLvl3 = $('.tor-header__menu-mobile-wrap').find('.nav-collection__title');
    if (linksLvl3.length) {
        linksLvl3.each(function () {
            if (!$(this).next('.nav-collection__list').length) {
                $(this).addClass('link-simple');
            }
        });
    }
}

function bindMenuMobileOnWindowResize() {
    $(window).resize(function () {
        if ($(window).width() > 991) {
            if ($('body').hasClass('nav-open')) {
                $('.hamburger').trigger('click');
            }
        }
    });
}

function bindBtnMenuMobileSearchOnClick() {
    $('#btnMenuMobileSearch').on('click', function () {
        $('.tor-header-mobile__search').slideToggle();
    });
}

function preventEventDefault(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
}

$(document).ready(function () {
    menuMobileInit();
    bindBtnMenuMobileSearchOnClick();
});
'use strict';

(function ($) {
    $(document).ready(function () {
        $(document).on('click', '.mw-option-radio .mw_options_list li', function (e) {
            var input = $(this).find('input');
            input.closest('ul').find('li').removeClass('item-checked');
            input.prop('checked', true);
            input.trigger('change');
            $(this).addClass('item-checked');
        });

        var blockImageSwitch = false;

        $('.mw-product-options').on('change', 'input, select', function (e) {
            if (blockImageSwitch) {
                return;
            }

            var key = [];
            $('.mw-product-options input:checked, .mw-product-options select').each(function (index, item) {
                key.push($(item).val().replace(/\s/g, '').toLowerCase());
            });
            var image = $('.rack-configuration-images [data-key-id="' + key.join('|') + '"]'),
                mainImage = $('.MagicZoomPlus');
            if (image.length && mainImage.length) {
                var imgSrc = image.attr('data-img-src');
                image.attr('href', imgSrc);
                image.attr('data-image', imgSrc);
                image.attr('data-image-2x', imgSrc);
                MagicZoom.update(mainImage.get(0), imgSrc, imgSrc);
            }
        });

        $('.rack-configuration-slider').on('click', 'a', function (e) {
            blockImageSwitch = true;
            var key = $(this).attr('data-key-id');
            var values = key.split('|');
            for (var i = 0; i < values.length; i++) {
                var option = $('.mw-product-options .mw-option')[i];
                option = $(option);
                if (option && option.is('.mw-option-radio')) {
                    option.find('input[value="' + values[i] + '"]').closest('li').trigger('click');
                } else if (option && option.is('.mw-option-swatch')) {
                    option.find('.swatch-value-container').each(function (index, item) {
                        var value = $(item).attr('data-value-text');
                        if (value && value.replace(/\s/g, '').toLowerCase() == values[i] && !$(item).is('.swatch-selected')) {
                            $(item).find('.swatch-value').trigger('click');
                        }
                    });
                }
            }
            blockImageSwitch = false;
        });

        if ($('.rack-configuration-slider').length) {
            $('.rack-configuration-slider a.slider-item').fancybox({
                baseClass: 'rack-view'
            });
        }

        //lazy load
        var lazyImages = [].slice.call(document.querySelectorAll('[data-bg-image]')),
            active = false,
            xRackLazyLoad = function xRackLazyLoad() {
            if (active === false) {
                active = true;

                setTimeout(function () {
                    lazyImages.forEach(function (lazyImage) {
                        if (lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0 && getComputedStyle(lazyImage).display !== "none") {
                            $(lazyImage).css('background-image', 'url("' + $(lazyImage).attr('data-bg-image') + '")');

                            lazyImages = lazyImages.filter(function (image) {
                                return image !== lazyImage;
                            });

                            if (lazyImages.length === 0) {
                                document.removeEventListener("scroll", xRackLazyLoad);
                                window.removeEventListener("resize", xRackLazyLoad);
                                window.removeEventListener("orientationchange", xRackLazyLoad);
                            }
                        }
                    });

                    active = false;
                }, 200);
            }
        };

        document.addEventListener("scroll", xRackLazyLoad);
        window.addEventListener("resize", xRackLazyLoad);
        window.addEventListener("orientationchange", xRackLazyLoad);
        xRackLazyLoad();

        $('.grouped-products-button').click(function () {
            $('.grouped-products').toggle(1);
        });

        $('.grouped-product-qty-plus').click(function () {
            var maxQty = parseInt($('#Quantity').val());
            var productId = $(this).data('product-id');
            var qtyInput = $('.product-qty-' + productId);
            var qty = parseInt(qtyInput.val()) + 1;
            if (qty <= maxQty) {
                qtyInput.val(qty);
                $('.grouped-product-qty.product-' + productId).html(qty);
            }
        });

        $('.grouped-product-qty-minus').click(function () {
            var productId = $(this).data('product-id');
            var qtyInput = $('.product-qty-' + productId);
            var qty = parseInt(qtyInput.val()) - 1;
            if (qty < 0) {
                qty = 0;
            }
            qtyInput.val(qty);
            $('.grouped-product-qty.product-' + productId).html(qty);
        });

        $(document).on('changeQty', function () {
            if ($('.grouped-products').length) {
                var groupedProducts = $('.grouped-product-input');
                var currentQty = parseInt($('#Quantity').val());
                $.each(groupedProducts, function () {
                    var qty = parseInt($(this).val());
                    if (qty > currentQty) {
                        var productId = $(this).data('product-id');
                        $('.grouped-product-qty.product-' + productId).html(currentQty);
                        $(this).val(currentQty);
                    }
                });
            }
        });
    });

    if ($('.rack-configuration-slider').length) {
        var qtyMap = {
            600: 2,
            900: 3
        };
        var itemsQty = 1;
        for (var key in qtyMap) {
            if (qtyMap.hasOwnProperty(key) && $(document).width() > key) {
                itemsQty = qtyMap[key];
            }
        }
        window.MagicScrollOptions = {
            items: itemsQty
        };

        $(window).on('resize', function () {
            itemsQty = 1;
            for (var key in qtyMap) {
                if (qtyMap.hasOwnProperty(key) && $(document).width() > key) {
                    itemsQty = qtyMap[key];
                }
            }
            window.MagicScrollOptions = {
                items: itemsQty
            };
            var scrollId = $('.rack-configuration-slider .MagicScroll').attr('id');
            MagicScroll.refresh(scrollId);
        });
    }

    var i = 0,
        mwInterval = setInterval(function () {
        if (window.mwProductOptions && window.mwProductOptions.hasInitialized || i++ > 50) {
            clearInterval(mwInterval);

            $('.mw-option-radio .mw_options_list input:checked').each(function (index, item) {
                $(item).closest('li').addClass('item-checked');
            });

            $('.configuration-option .swatch-value-container').each(function (index, item) {
                item = $(item);
                if (item.attr('data-value-text')) {
                    item.append('<div class="configuration-option-title">' + item.attr('data-value-text') + '</div>');
                }
            });
        }
    }, 200);
})(jQuery);
'use strict';

var isMobile = {
    Android: function Android() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function BlackBerry() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function iOS() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function Opera() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function Windows() {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function any() {
        return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
    }
};

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function setCookie(cname, cvalue, exdays, exhours) {
    var d = new Date();

    if (exdays == 0 && exhours > 0) {
        d.setTime(d.getTime() + exhours * 60 * 60 * 1000);
    } else {
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    }

    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function checkRedirect(className) {
    var element = $('.redirect-check');
    if (element.length) {
        var url = element.data('url');
        url = typeof url == "undefined" || url == '' ? '/' : url;

        if (element.hasClass(className)) {
            window.location.href = url;
        }
    }
}

(function ($) {
    var currentProductTitle = 'currentProductTitle';
    var currentProductSku = 'currentProductSku';
    var currentProductInfo = 'currentProductInfo';
    var currentProductLink = 'currentProductLink';

    function currentProductInit() {
        //currentProduct var has been set in product.liqud
        if (typeof currentProduct !== 'undefined') {
            setCookie(currentProductTitle, currentProduct.title, 1);
            setCookie(currentProductSku, currentProduct.variants[0].sku, 1);
            dataXRackInfo();
        } else {
            setCookie(currentProductTitle, '', -1);
            setCookie(currentProductSku, '', -1);
            setCookie(currentProductInfo, '', -1);
        }
    }

    function dataXRackInfo() {
        if ($('.mw-product-options').length) {
            setTimeout(setDataXRackInfo, 6000);

            //Event
            $('.mw-product-options').on('change', 'input, select', function (e) {
                setDataXRackInfo();
            });
        }
    }

    function setDataXRackInfo() {
        var result = [];

        $('.mw-product-options input:checked, .mw-product-options select').each(function (index, item) {
            var elem = $(item);
            var id = elem.attr('id');
            var label = $("label[for='" + id + "']").text();

            if (label == '') {
                label = elem.attr('name').match(/\[(.*?)\]/g).map(function (val) {
                    return val.replace(/\[|\]/g, '');
                });

                label = label[0] ? label[0] : '';
                label += ' - ' + elem.val().replace(/\s/g, '').toLowerCase();
            }

            result.push(label);
        });

        setCookie(currentProductInfo, result.join('|||'), 1);
        setProductInfoInForm();
    }

    function mainCollectionInit() {
        var collectionCarousel = $('.main-collection__carousel');
        var sliderArrows = window.sliderArrows || false;
        var nextArrow, prevArrow;

        // sliderArrows is an object defined in collection.main.liquid to set custom
        // SVG arrow icons.
        if (sliderArrows) {
            nextArrow = '<button type="button" class="slick-next"><span>' + sliderArrows.right + '</span></button>';
            prevArrow = '<button type="button" class="slick-prev"><span>' + sliderArrows.left + '</span></button>';
        }

        if (collectionCarousel.length) {
            collectionCarousel.slick({
                accessibility: false,
                adaptiveHeight: true,
                arrows: true,
                dots: false,
                infinite: false,
                autoplay: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                nextArrow: nextArrow,
                prevArrow: prevArrow,
                responsive: [{
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 1.5,
                        slidesToScroll: 1,
                        infinite: false
                    }
                }]
            });
        }
    }

    function generateProductInfo(title, sku, link, info) {
        var productInfo = "Product Name: " + title + "\n";
        productInfo += "SKU: " + sku + "\n";
        if (info) {
            productInfo += "\nSelected Options:\n" + info.split("|||").join("\n") + "\n\n";
        }
        productInfo += "Link: " + link;

        return productInfo;
    }

    function contactMoreInfo() {
        var formElm = $('.contact-more-info_form-wrap');

        if (formElm.length) {
            initNiceSelect(formElm);
            initFormPlaceholders(formElm);
            initBranchingLogic(formElm);
            setProductInfoInForm();
        }
    }

    function setProductInfoInForm() {
        var productTitle = void 0,
            productSku = void 0,
            productData = void 0;
        var productInfo = getCookie(currentProductInfo);

        if (typeof currentProduct !== 'undefined') {
            productData = generateProductInfo(currentProduct.title, currentProduct.variants[0].sku, window.location.href, productInfo);
        } else {
            productTitle = getCookie(currentProductTitle);
            productSku = getCookie(currentProductSku);

            if (productTitle) {
                productData = generateProductInfo(productTitle, productSku, document.referrer, productInfo);
            }
        }

        if (productData) {
            $('textarea[name="contact[product_info]"]').val(productData);
        }
    }

    function initBranchingLogic(form) {
        var elem = form.find('.branching');

        elem.change(function () {
            var group = $('template#' + $(this).val());
            var template = group.length ? group.html() : '';

            $('.branching-content').html(template);
        });
    }

    function updateMagicScroll() {
        if (typeof MagicScrollOptions !== 'undefined' && isMobile.any()) {
            MagicScrollOptions.items = 3;
        }
    }

    function smoothScroll() {
        $("a.scroll").on('click', function (event) {
            if (this.hash !== "") {
                var hash = this.hash;
                event.preventDefault();

                $('html, body').animate({
                    scrollTop: $(hash).offset().top
                }, 800, function () {
                    window.location.hash = hash;
                });
            }
        });
    }

    function slider() {
        if ($('#slider').length) {
            $('#slider').slick({
                prevArrow: $('.hero__arrow--prev'),
                nextArrow: $('.hero__arrow--next'),
                dots: true,
                autoplaySpeed: 7000,
                lazyLoad: 'progressive'
            });
        }
    }

    function xcreate() {
        if ($('.x-create').length) {
            var setSectionsHeight = function setSectionsHeight() {
                $('#section-two').height($('#section-two .section-column-second').height());
                $('#section-four').height($('#section-four .section-column-second').height());

                $('#section-six').height($('#section-six .section-column-second').height());
                $('#section-seven').height($('#section-seven .section-column-second').height());

                $('#section-nine').height($('#section-nine .section-column-second').height());

                $('#section-eleven').height($('#section-eleven .section-column-second').height());
            };

            var initGallery = function initGallery() {
                var collectionCarousel = $('.section-gallery-wrapper');
                var sliderArrows = window.sliderArrows || false;
                var nextArrow, prevArrow;

                // sliderArrows is an object defined in collection.main.liquid to set custom
                // SVG arrow icons.
                if (sliderArrows) {
                    nextArrow = '<button type="button" class="slick-next"><span>' + sliderArrows.right + '</span></button>';
                    prevArrow = '<button type="button" class="slick-prev"><span>' + sliderArrows.left + '</span></button>';
                }

                if (collectionCarousel.length) {
                    collectionCarousel.slick({
                        accessibility: false,
                        adaptiveHeight: true,
                        arrows: true,
                        dots: false,
                        infinite: false,
                        autoplay: false,
                        slidesToShow: 6,
                        slidesToScroll: 6,
                        nextArrow: nextArrow,
                        prevArrow: prevArrow,
                        responsive: [{
                            breakpoint: 750,
                            settings: {
                                slidesToShow: 1.5,
                                slidesToScroll: 1,
                                infinite: false
                            }
                        }]
                    });
                }
            };

            var sectionAnimation = function sectionAnimation(currentSection, previousSection, event) {
                var isVisible = inViewport($(currentSection));
                var sectionOffset = inViewport($(currentSection));
                var prevOffset = inViewport($(previousSection));
                if (event.originalEvent.deltaY > 0) {
                    if (isVisible && sectionOffset > 0) {
                        if (prevOffset === 0) {
                            if ($(currentSection).attr('id') === 'section-six' && !videoOpened) {
                                videoOpened = true;
                                event.preventDefault();
                                return;
                            }
                            $(currentSection).addClass('opened');
                            $('.menu-item').removeClass('active');
                            var id = $(currentSection).attr('id');
                            $('.menu-item[href="#' + id + '"]').addClass('active');
                        }
                    }
                } else {
                    if (isVisible && prevOffset > 0) {
                        $(currentSection).removeClass('opened');
                        $('.menu-item').removeClass('active');
                    }
                }
            };

            var inViewport = function inViewport($el) {
                var elH = $el.outerHeight(),
                    H = $(window).height(),
                    r = $el[0].getBoundingClientRect(),
                    t = r.top,
                    b = r.bottom;
                return Math.max(0, t > 0 ? Math.min(elH, H - t) : Math.min(b, H));
            };

            $('#shopify-section-tor-header').css({ position: 'absolute', top: '0px', zIndex: '10', width: '100%' });
            $('[data-fancybox="gallery"]').fancybox({
                fitToView: false
            });
            document.getElementById('functional-video').playbackRate = 0.5;
            var videoOpened = false;

            $('.menu-item').click(function (e) {
                $('.menu-item').removeClass('active');
                $(this).addClass('active');
                var url = $(this).attr('href');
                $('html, body').animate({
                    scrollTop: $(url).offset().top
                }, 2000);
                e.preventDefault();
                return false;
            });

            $('.more-info').click(function (e) {
                $('html, body').animate({
                    scrollTop: $('#section-twelve').offset().top
                }, 2000);
                e.preventDefault();
                return false;
            });

            $('.section-gallery-close').click(function () {
                $('#section-gallery').removeClass('opened');
                $('body').removeClass('overflow-hidden');
                return false;
            });

            $('#section-two .show-item-description').click(function (e) {
                $('html body').addClass('stop-scrolling');
                $('#section-modal-build').addClass('active');
            });

            $('#section-modal-build .modal-close').click(function (e) {
                $('#section-modal-build').removeClass('active');
                $('html body').removeClass('stop-scrolling');
                e.preventDefault();
            });

            $('#section-four .show-item-description').click(function (e) {
                $('html body').addClass('stop-scrolling');
                $('#section-modal-features').addClass('active');
            });

            $('#section-modal-features .modal-close').click(function (e) {
                $('#section-modal-features').removeClass('active');
                $('html body').removeClass('stop-scrolling');
                e.preventDefault();
            });

            $('#section-six .show-item-description').click(function (e) {
                $('html body').addClass('stop-scrolling');
                $('#section-modal-functional-training').addClass('active');
            });

            $('#section-modal-functional-training .modal-close').click(function (e) {
                $('#section-modal-functional-training').removeClass('active');
                $('html body').removeClass('stop-scrolling');
                e.preventDefault();
            });

            $('#section-seven .show-item-description').click(function (e) {
                $('html body').addClass('stop-scrolling');
                $('#section-modal-modules').addClass('active');
            });

            $('#section-modal-modules .modal-close').click(function (e) {
                $('#section-modal-modules').removeClass('active');
                $('html body').removeClass('stop-scrolling');
                e.preventDefault();
            });

            $('#section-nine .show-item-description').click(function (e) {
                $('html body').addClass('stop-scrolling');
                $('#section-modal-attachments').addClass('active');
            });

            $('#section-modal-attachments .modal-close').click(function (e) {
                $('#section-modal-attachments').removeClass('active');
                $('html body').removeClass('stop-scrolling');
                e.preventDefault();
            });

            setSectionsHeight();
            initGallery();

            $('.button-play').on('click', function (ev) {
                $('.section-video-layout').hide();
                $("#video")[0].src += "&autoplay=1";
                ev.preventDefault();
            });

            $('.main-container').on('wheel', '#section-one', function (event) {
                var currentSection = $('#section-one');
                var menuShopfiy = $('#shopify-section-tor-header');
                var menuXcreate = $('.x-create-menu');
                var fadeIn = 'fade-in-animation';
                var fadeOut = 'fade-out-animation';
                var height = $(currentSection).height();
                var scrollTop = $(window).scrollTop();
                if (event.originalEvent.deltaY > 0) {
                    if (scrollTop > 0 && !$(currentSection).hasClass('opened')) {
                        $('#section-one').addClass('opened');
                        $(menuShopfiy).removeClass(fadeIn).addClass(fadeOut);
                        $(menuXcreate).removeClass(fadeOut).addClass(fadeIn);
                    }
                    var opacity = scrollTop / height * 3;
                    $('.section-wrapper').css({ opacity: opacity });
                } else {
                    if (scrollTop === 0) {
                        $('#section-one').removeClass('opened');
                        $(menuShopfiy).removeClass(fadeOut).addClass(fadeIn);
                        $(menuXcreate).removeClass(fadeIn).addClass(fadeOut);
                    }
                    var opacity = scrollTop / height * 3;
                    $('.section-wrapper').css({ opacity: opacity });
                }
            });

            $('.main-container').on('wheel', '.x-section', function (event) {
                sectionAnimation($('#section-two'), $('#section-one'), event);

                sectionAnimation($('#section-four'), $('#section-three'), event);

                sectionAnimation($('#section-six'), $('#section-five'), event);

                sectionAnimation($('#section-seven'), $('#section-six'), event);

                sectionAnimation($('#section-eight'), $('#section-seven'), event);

                sectionAnimation($('#section-nine'), $('#section-eight'), event);

                sectionAnimation($('#section-eleven'), $('#section-ten'), event);
            });
        }
    }

    if (window.performance && window.performance.navigation.type === 2) {
        window.location.reload();
    }

    function modalVideoInit() {
        if ($('.venobox').length) {
            $('.venobox').venobox();
        }
    }

    function drawLines() {
        if ($('.tank-content-block-main-option').length) {
            $('.tank-content-block-main-option').hover(function () {
                $('.dot-left, .dot-right, .dot-description').hide();
                $(this).find('div').show();
            });
            $('.tank-content-block-main-option').on('mouseleave, mouseout', function () {
                $('.dot-left, .dot-right, .dot-description').hide();
            });
        }
    }

    function needMoreInfoButton() {
        if ($('.product-single__more-info').length) {
            $('.product-single__more-info').click(function () {
                ga(function(tracker) {
  					var clientId = tracker.get('clientId');
                    setCookie('ga_client_id', clientId, 90);

                });
                if (currentProduct !== 'undefined') {
                    setCookie(currentProductLink, currentProduct.url, 90);
                }
            });
        }
    }

    $(document).ready(function () {
        mainCollectionInit();
        contactMoreInfo();
        currentProductInit();
        updateMagicScroll();
        smoothScroll();
        slider();
        modalVideoInit();
        drawLines();
        xcreate();
        needMoreInfoButton();
    });
})(jQuery);
'use strict';

function bindSearchInputsValue() {
    var searchInput = $('.tor-header__search').find('.tor-header__search-input');
    var searchMobileInput = $('.tor-header-mobile__search').find('.tor-header__search-input');

    searchInput.on('DOMAttrModified textInput input change keypress paste focus', function () {
        searchMobileInput.val($(this).val());
    });

    searchMobileInput.on('DOMAttrModified textInput input change keypress paste focus', function () {
        searchInput.val($(this).val());
    });
}

function bindSearchInputOnHoverHandler(searchInputWrap) {
    searchInputWrap.hover(function () {
        doSearchInputHoverIn($(this));
    }, function () {
        doSearchInputHoverOut($(this));
    });
}

function bindSearchInputFocusHandler(searchInput) {
    searchInput.on('focus', function () {
        doSearchInputHoverIn($(this));
    });

    searchInput.on('blur', function () {
        doSearchInputHoverOut($(this));
    });
}

function bindSearchInputOnChangeHandler(searchInput) {
    searchInput.on('DOMAttrModified textInput input change keypress paste', function () {
        if (searchInput.val() && searchInput.val() != '') {
            doSearchInputHoverIn($(this).parent());
        } else {
            hideSearchInputBtnClear($(this));
        }
    });
}

function initSearchInputBtnClear() {
    initSearchInputDesktopBtnClear();
    initSearchInputMobileBtnClear();
}

function initSearchInputDesktopBtnClear() {
    var searchInputWrap = $('.tor-header__search').find('.tor-header__search-input-wrap');
    var searchInput = $('.tor-header__search').find('.tor-header__search-input');
    bindSearchInputOnHoverHandler(searchInputWrap);
    bindSearchInputFocusHandler(searchInput);
    bindSearchInputOnChangeHandler(searchInput);
    bindSearchInputBtnClearClick(searchInput, clearSearchInputs);
}

function initSearchInputMobileBtnClear() {
    var searchInputWrap = $('.tor-header-mobile__search').find('.tor-header__search-input-wrap');
    var searchInput = $('.tor-header-mobile__search').find('.tor-header__search-input');
    bindSearchInputOnHoverHandler(searchInputWrap);
    bindSearchInputFocusHandler(searchInput);
    bindSearchInputOnChangeHandler(searchInput);
    bindSearchInputBtnClearClick(searchInput, clearSearchInputs);
}

function initSearchInputBlogNewsBtnClear() {
    var searchInputWrap = $('.tor-blog-news_search').find('.tor-header__search-input-wrap');
    var searchInput = $('.tor-blog-news_search').find('.tor-header__search-input');
    bindSearchInputOnHoverHandler(searchInputWrap);
    bindSearchInputFocusHandler(searchInput);
    bindSearchInputOnChangeHandler(searchInput);
    bindSearchInputBtnClearClick(searchInput, clearBlogNewsSearchInput);
}

function doSearchInputHoverIn(searchInputWrap) {
    var searchInput = searchInputWrap.find('.tor-header__search-input');
    if (searchInput.val() && searchInput.val() != '') {
        showSearchInputBtnClear(searchInput);
    }
}

function showSearchInputBtnClear(searchInput) {
    var clearBtn = getSearchInputBtnClear(searchInput);
    clearBtn.show();
}

function hideSearchInputBtnClear(searchInput) {
    var clearBtn = getSearchInputBtnClear(searchInput);
    clearBtn.hide();
}

function getSearchInputBtnClear(searchInput) {
    var clearBtn = searchInput.parent().find('.search-btn-clear');
    return clearBtn;
}

function doSearchInputHoverOut(searchInput) {
    var btnClear = getSearchInputBtnClear(searchInput);
    if (!(btnClear.is(':hover') || btnClear.is(':focus'))) {
        hideSearchInputBtnClear(searchInput);
    }
}

function bindSearchInputBtnClearClick(searchInput, fnClear) {
    var clearBtn = getSearchInputBtnClear(searchInput);
    clearBtn.on('click', function () {
        //clearSearchInputs();
        fnClear();
        $(this).hide();
    });
}

function clearSearchInputs() {
    var searchInputDesktop = $('.tor-header__search').find('.tor-header__search-input');
    var searchInputMobile = $('.tor-header-mobile__search').find('.tor-header__search-input');

    searchInputDesktop.val('');
    searchInputMobile.val('');
}

function clearBlogNewsSearchInput() {
    var searchInput = $('.tor-blog-news_search').find('.tor-header__search-input');
    searchInput.val('');
}

$(document).ready(function () {
    bindSearchInputsValue();
    initSearchInputBtnClear();
});
"use strict";

/* Showcase tag scroller */
var SETTINGS = {
    navBarTravelling: false,
    navBarTravelDirection: "",
    navBarTravelDistance: 150
};

var colours = {
    0: "#fc331a"
};

document.documentElement.classList.remove("no-js");
document.documentElement.classList.add("js");

var pnAdvancerLeft = document.getElementById("pnAdvancerLeft");
var pnAdvancerRight = document.getElementById("pnAdvancerRight");
var pnIndicator = document.getElementById("pnIndicator");

var tagScrollerNav = document.getElementById("tagScrollerNav");
var tagScrollerNavContents = document.getElementById("tagScrollerNavContents");

var last_known_scroll_position = 0;
var ticking = false;

function doSomething(scroll_pos) {
    tagScrollerNav.setAttribute("data-overflowing", determineOverflow(tagScrollerNavContents, tagScrollerNav));
}

function moveIndicator(item, color) {
    var textPosition = item.getBoundingClientRect();
    var container = tagScrollerNavContents.getBoundingClientRect().left;
    var distance = textPosition.left - container;
    var scroll = tagScrollerNavContents.scrollLeft;
    pnIndicator.style.transform = "translateX(" + (distance + scroll) + "px) scaleX(" + textPosition.width * 0.01 + ")";

    if (color) {
        pnIndicator.style.backgroundColor = color;
    }
}

function determineOverflow(content, container) {
    var containerMetrics = container.getBoundingClientRect();
    var containerMetricsRight = Math.floor(containerMetrics.right);
    var containerMetricsLeft = Math.floor(containerMetrics.left);
    var contentMetrics = content.getBoundingClientRect();
    var contentMetricsRight = Math.floor(contentMetrics.right);
    var contentMetricsLeft = Math.floor(contentMetrics.left);
    if (containerMetricsLeft > contentMetricsLeft && contentMetricsRight - containerMetricsRight > 2) {
        return "both";
    } else if (contentMetricsLeft < containerMetricsLeft) {
        return "left";
    } else if (contentMetricsRight - containerMetricsRight > 2) {
        return "right";
    } else {
        return "none";
    }
}

function bindTagScrollerAttrOverflowingOnResize() {
    $(window).resize(function () {
        tagScrollerNav.setAttribute("data-overflowing", determineOverflow(tagScrollerNavContents, tagScrollerNav));
    });
}

function initTagScroller() {
    moveIndicator(tagScrollerNav.querySelector("[aria-selected=\"true\"]"), colours[0]);
    tagScrollerNav.setAttribute("data-overflowing", determineOverflow(tagScrollerNavContents, tagScrollerNav));
    bindTagScrollerAttrOverflowingOnResize();

    tagScrollerNav.addEventListener("scroll", function () {
        last_known_scroll_position = window.scrollY;
        if (!ticking) {
            window.requestAnimationFrame(function () {
                doSomething(last_known_scroll_position);
                ticking = false;
            });
        }
        ticking = true;
    });

    pnAdvancerLeft.addEventListener("click", function () {
        if (SETTINGS.navBarTravelling === true) {
            return;
        }
        if (determineOverflow(tagScrollerNavContents, tagScrollerNav) === "left" || determineOverflow(tagScrollerNavContents, tagScrollerNav) === "both") {
            var availableScrollLeft = tagScrollerNav.scrollLeft;
            if (availableScrollLeft < SETTINGS.navBarTravelDistance * 2) {
                tagScrollerNavContents.style.transform = "translateX(" + availableScrollLeft + "px)";
            } else {
                tagScrollerNavContents.style.transform = "translateX(" + SETTINGS.navBarTravelDistance + "px)";
            }
            tagScrollerNavContents.classList.remove("tagScrollerNav_Contents-no-transition");
            SETTINGS.navBarTravelDirection = "left";
            SETTINGS.navBarTravelling = true;
        }
        tagScrollerNav.setAttribute("data-overflowing", determineOverflow(tagScrollerNavContents, tagScrollerNav));
    });

    pnAdvancerRight.addEventListener("click", function () {
        if (SETTINGS.navBarTravelling === true) {
            return;
        }
        if (determineOverflow(tagScrollerNavContents, tagScrollerNav) === "right" || determineOverflow(tagScrollerNavContents, tagScrollerNav) === "both") {
            var navBarRightEdge = tagScrollerNavContents.getBoundingClientRect().right;
            var navBarScrollerRightEdge = tagScrollerNav.getBoundingClientRect().right;
            var availableScrollRight = Math.floor(navBarRightEdge - navBarScrollerRightEdge);
            if (availableScrollRight < SETTINGS.navBarTravelDistance * 2) {
                tagScrollerNavContents.style.transform = "translateX(-" + availableScrollRight + "px)";
            } else {
                tagScrollerNavContents.style.transform = "translateX(-" + SETTINGS.navBarTravelDistance + "px)";
            }
            tagScrollerNavContents.classList.remove("tagScrollerNav_Contents-no-transition");
            SETTINGS.navBarTravelDirection = "right";
            SETTINGS.navBarTravelling = true;
        }
        tagScrollerNav.setAttribute("data-overflowing", determineOverflow(tagScrollerNavContents, tagScrollerNav));
    });

    tagScrollerNavContents.addEventListener("transitionend", function () {
        var styleOfTransform = window.getComputedStyle(tagScrollerNavContents, null);
        var tr = styleOfTransform.getPropertyValue("-webkit-transform") || styleOfTransform.getPropertyValue("transform");
        var amount = Math.abs(parseInt(tr.split(",")[4]) || 0);
        tagScrollerNavContents.style.transform = "none";
        tagScrollerNavContents.classList.add("tagScrollerNav_Contents-no-transition");
        if (SETTINGS.navBarTravelDirection === "left") {
            tagScrollerNav.scrollLeft = tagScrollerNav.scrollLeft - amount;
        } else {
            tagScrollerNav.scrollLeft = tagScrollerNav.scrollLeft + amount;
        }
        SETTINGS.navBarTravelling = false;
    }, false);

    tagScrollerNavContents.addEventListener("click", function (e) {
        var links = [].slice.call(document.querySelectorAll(".tagScrollerNav_Link"));

        links.forEach(function (item) {
            item.setAttribute("aria-selected", "false");
        });

        var clickTarget;

        if ($(e.target).parent().hasClass("tagScrollerNav_Link")) {
            $(e.target).parent().attr("aria-selected", "true");
            clickTarget = $(e.target).parent()[0];
        } else {
            e.target.setAttribute("aria-selected", "true");
            clickTarget = e.target;
        }
        moveIndicator(clickTarget, colours[links.indexOf(clickTarget)]);
    });
}

function initShowcaseTagDropDown() {
    doInitShowcaseTagDropDown();
    $(window).resize(function () {
        doInitShowcaseTagDropDown();
    });
}

function doInitShowcaseTagDropDown() {
    if (window.innerWidth < 768) {
        if (!$('.tag-scroller_wrapper_dropdown').length > 0) {
            createShowcaseTagDropDown();
            bindDropDownOutClick();
        }
    } else {
        if ($('.tag-scroller_wrapper_dropdown').length > 0) {
            destroyShowcaseTagDropDown();
            unbindDropDownOutClick();
        }
    }
}

function createShowcaseTagDropDown() {
    $('.tag-scrollerNav').hide();
    var container = $('.tag-scroller_wrapper');
    container.addClass('tag-scroller_wrapper_dropdown');
    var dropDownSelected = $('<div class="tag-scroller_dropdown-selected"/>');
    dropDownSelected.html($('.tag-scroller_wrapper_dropdown').find('[aria-selected="true"] > *').html());
    container.prepend(dropDownSelected);
    bindShowcaseTagDropDownOnClick();
    bindShowcaseTagDropDownItemOnClick();
}

function bindShowcaseTagDropDownOnClick() {
    $('.tag-scroller_dropdown-selected').on('click', function () {
        toggleShowcaseTagDropDownList();
    });
}

function bindShowcaseTagDropDownItemOnClick() {
    var item = $('.tag-scroller_wrapper').find('li');
    item.on('click', function () {
        toggleShowcaseTagDropDownList();
    });
}

function toggleShowcaseTagDropDownList() {
    $('.tag-scrollerNav').slideToggle();
}

function destroyShowcaseTagDropDown() {
    var container = $('.tag-scroller_wrapper');
    var dropDownSelected = container.find('.tag-scroller_dropdown-selected');
    dropDownSelected.off('click');
    dropDownSelected.remove();

    var item = container.find('li');
    item.off('click');

    container.removeClass('tag-scroller_wrapper_dropdown');
    $('.tag-scrollerNav').show();
}

function bindDropDownOutClick() {
    $(document).on('click', doDropDownOutClick);
}

function doDropDownOutClick(e) {
    if (!$(e.target).closest('.tag-scroller_wrapper_dropdown').length) {
        if ($('#tagScrollerNav').is(":visible")) {
            $('.tag-scrollerNav').slideUp();
        }
    }
}

function unbindDropDownOutClick() {
    $(document).off('click', doDropDownOutClick);
}
